<template>
    <div class="section-bots">
      <component-loader :progress="90" :unlimitedProgress="true" v-if="showLoader" :activeClose="true" v-on:close="showLoader = false"></component-loader>

      <!--<div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs('list')">
        <div class="table-title" @click="toggleExpandTabs">
            <p>{{$t('dash.bots.title')}}</p>
        </div>
        <div class="show-setting">
          <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
          <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i>
        </div>
        <div class="search-page">
          <vs-input
           @keypress.enter.prevent
            v-model="pageFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.page_filter')"
          />
        </div>
        <ul>
          <li class="group" v-for="group in groups" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group)}]">
            <div class="group-wrapper">
              <img v-if="!group.show" @click="toggleShowGroup(group)" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg"/>
              <img v-else @click="toggleShowGroup(group)" alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
              <div class="group-content">
                <Tooltip :text="group.name" position="top">
                  <p class="group-name"><span>{{ `${group.name.substr(0, 14)}${group.name.length > 15 ? ' ...' : ''}` }}</span></p>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :id="`groups-${group.id}`"
                  name="groups[]"
                  :value="group.id"
                  v-model="selectedGroups"
                  @change="checkGroup(group)"
                  :disabled="!isUserPremiumActive && !isUserPartner"
                >
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
              </div>
            </div>
            <ul>
              <div v-for="item in group.pages" :key="item">
                <li class="page" v-if="findPage(item)"
                      :class="[{ disabled: !checkLock(findPage(item).network), 'hide': !checkPageFilter(findPage(item)) }]">
                  <div class="page-wrapper" :class="{disabled: !checkLock(findPage(item).network)}">
                    <div class="checkbox">
                      <input
                        type="checkbox"
                        :id="`pages-${findPage(item).id}`"
                        name="pages[]"
                        :value="findPage(item)"
                        v-model="selectedPages"
                        :disabled="!isUserPremiumActive && !isUserPartner"
                      >
                      <span class="checkmark"> 
                        <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                      </span>
                    </div>
                    <div class="page-content">
                      <Tooltip :text="findPage(item).name" position="top">
                        <page-image-avatar :page="findPage(item)"/>
                        <p class="page-name">
                          <span>{{ `${findPage(item).name.substr(0, 14)}${findPage(item).name.length > 15 ? ' ...' : ''}` }}</span>
                        </p>
                        &nbsp;
                      </Tooltip>
                    </div>
                  </div>
                </li>
              </div>
            </ul>
          </li>
          <li class="page" v-for="(item, index) in gridData" :key="item.pages.id"
                :class="[{ disabled: !checkLock(item.pages.network), 'hide': !checkPageFilter(item.pages) || pageInGroup(item.pages) }]">
            <div class="page-wrapper" :class="{disabled: !checkLock(item.pages.network) || (!isUserPremiumActive && index != 0 && !isUserPartner)}">
              <i class="material-icons">navigate_next</i>
              <div class="page-content">
                <Tooltip :text="item.pages.name" position="top">
                  <page-image-avatar :page="item.pages"/> 
                  <p class="page-name"><span>{{ `${item.pages.name.substr(0, 14)}${item.pages.name.length > 15 ? ' ...' : ''}` }}</span></p>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="checkbox">
                <input
                  type="checkbox"
                  :id="`pages-${item.pages.id}`"
                  name="pages[]"
                  :value="item.pages"
                  v-model="selectedPages"
                  :disabled="!isUserPremiumActive && !isUserPartner"
                >
                <span class="checkmark">
                  <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>-->
      <div class="pages-sidebar head">
        <div class="table-title">
            <p>{{$t('dash.bots.title')}}</p>
        </div>
      </div>
    
        <vs-popup title="Authentification à deux facteurs" :active.sync="twoFactorPopup" class="two-factor-authentification">
          <TwoFactorAuthenticationPopup :pageid="twoFactorPopup" :pages="pages" @closePopup="closePopup"/>
        </vs-popup>
        <vs-row class="bots-main" v-show="this.activeSection === 'main'">
            <vs-col vs-justify="center" vs-align="center" vs-w="12">
                <!--<div class="table-title">
                    <p>{{ $t('dash.bots.title') }}</p>
                </div>
                <p class="subtitle">{{ $t('dash.bots.subtitle') }}</p>-->

                <vs-button
                        class="btn-large btn-img"
                        color="#303030"
                        @click="initBot"
                        vs-type="filled"
                        data-qa="add-bot"
                >
                    <p>{{ $t('dash.bots.add') }}</p>
                    <img src="../../../assets/img/icon_flash_white.svg" alt="search" />
                </vs-button>

                <div class="search-page">
                  <vs-input
                  @keypress.enter.prevent
                    v-model="pageFilter"
                    :class="{'input': true}"
                    color="#B20564"
                    class="inputx"
                    icon-after="true"  icon="search"
                    :placeholder="$t('dash.settings.user.label.page_filter')"
                  />
                </div>

                <!-- <div @click="showEnabledBots = !showEnabledBots" class="bots-enabled-disabled" v-if="enabledBotsExists">
                  {{ !showEnabledBots ? $t('dash.bots.show.enabled') : $t('dash.bots.show.disabled') }}
                </div> -->

                <div v-if="botsCount > 0" class="bots-wrapper">
                    <component-multipletable
                            :gridData="gridData.filter(item => selectedPages.find(page => page.id == item.pages.id && checkPageFilter(item.pages)))"
                            :columns="gridColumns"
                            @edit="editBot"
                            @create="initBot"
                            :name="'bots'"
                            :key="keyListBots"
                    ></component-multipletable>
                </div>
                <div v-else>
                  <!-- TODO: -->
                </div>
            </vs-col>
        </vs-row>

        <vs-row class="bots-new" :class="[this.activeSection, {'accordeon': !tabsIsMinimize}]" v-show="this.activeSection === 'new' || this.activeSection === 'edit'">
          <!-- <div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs('form')"> -->
          <div class="pages-sidebar" :class="{'contract': tabsIsMinimize}">
            <div class="table-title" @click="toggleExpandTabs">
                <p>{{$t('dash.bots.title')}}</p>
            </div>
            <div class="show-setting">
              <!-- <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
              <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i> -->
              <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="!tabsIsMinimize">navigate_before</i>
              <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="tabsIsMinimize">navigate_next</i>
            </div>
            <div class="search-page">
              <vs-input
               @keypress.enter.prevent
                v-model="pageFilter"
                :class="{'input': true}"
                color="#B20564"
                class="inputx"
                icon-after="true"  icon="search"
                :placeholder="$t('dash.settings.user.label.page_filter')"
              />
            </div>
            <ul>
              <li class="group" v-for="group in groups" :key="group.id" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]" 
                                        v-show="activeSection === 'new'">
                <div class="group-wrapper" @click="toggleShowGroup(group)">
                  <img v-if="!group.show" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg"/>
                  <img v-else alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                  <div class="group-content">
                    <Tooltip :text="group.name" position="top">
                      <p class="group-name"><span>{{ `${group.name.substr(0, 14)}${group.name.length > 15 ? ' ...' : ''}` }}</span></p>
                      &nbsp;
                    </Tooltip>
                  </div>
                  <!--<div class="checkbox">
                    <input
                      type="checkbox"
                      :id="`groups-${group.id}`"
                      name="groups[]"
                      :value="group.id"
                      v-model="selectedGroups"
                      @change="checkGroup(group)"
                    >
                    <span class="checkmark"></span>
                  </div>-->
                </div>
                <ul>
                  <div v-for="item in group.pages" :key="item">
                    <li class="page" v-if="findPage(item)"
                        :class="[{ disabled: !checkLock(findPage(item).network), 'hide': !checkPageFilter(findPage(item)) }]">
                      <div class="page-wrapper" :class="{disabled: !checkLock(findPage(item).network)}">
                        <div class="checkbox">
                          <input
                            type="radio"
                            :id="`page-index-${findPage(item).id}`"
                            name="page"
                            :value="findPage(item).id"
                            v-model="bot.page"
                            :disabled="!checkLock(findPage(item).network)"
                            @click="addDefaultBotName(findPage(item)); getHighlightsInstagramList(findPage(item))"
                            :data-qa="'form-bot-page-selector-'+findPage(item).network"
                          />
                          <span class="checkmark">                  
                            <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                          </span>
                        </div>
                        <div class="page-content">
                          <page-image-avatar :page="findPage(item)"/>
                          <p class="page-name">
                            <span>{{ `${findPage(item).name.substr(0, 14)}${findPage(item).name.length > 15 ? ' ...' : ''}` }}</span>
                          </p>
                        </div>
                      </div>
                    </li>
                  </div>
                </ul>
              </li>
              <li class="page" v-for="(item, index) in linkedPages" :key="item.id" 
                      v-show="activeSection === 'new' || (activeSection === 'edit' && bot.page == item.id)"
                      :class="[{ disabled: !checkLock(item.network), 'hide': !checkPageFilter(item) || (activeSection === 'new' && pageInGroup(item)) }]">
                <div class="page-wrapper" :class="{disabled: !checkLock(item.network)}" v-if="activeSection === 'edit' || !pageInGroup(item)">
                  <!--<i class="material-icons">navigate_next</i>-->
                  <div class="page-content">
                    <page-image-avatar :page="item"/>
                    <p class="page-name">
                      <span>{{ `${item.name.substr(0, 14)}${item.name.length > 15 ? ' ...' : ''}` }}</span>
                    </p>
                  </div>
                  <div class="checkbox">
                    <input
                      type="radio"
                      :id="`page-index-${index}`"
                      name="page"
                      :value="item.id"
                      v-model="bot.page"
                      :disabled="!checkLock(item.network)"
                      @click="addDefaultBotName(item); getHighlightsInstagramList(item)"
                      :data-qa="'form-bot-page-selector-'+item.network"
                    />
                    <span class="checkmark">
                      <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
            <vs-col vs-justify="center" vs-align="center" vs-w="12">
                <!-- <form @submit.prevent="submit('bot')" data-vv-scope="bot"> -->
                <form data-vv-scope="bot">
                    <div class="table-title">
                      <p>{{
                        $t(`dash.bots.${ editedBotExists ? 'edit' : 'add' }`)
                      }}</p>

                      <vs-button
                        color="#303030"
                        class="btn-large btn-cancel"
                        @click.prevent.stop="cleanData"
                        vs-type="filled"
                        style="float: right; transform: translateY(-33%)"
                      >{{ $t('dash.button.cancel') }}</vs-button>
                    </div>

                    <div class="bots-wrapper">
                        <div class="table-subtitle" v-if="activeSection === 'new' && !bot.page">
                            <p>{{ $t('dash.bots.pages') }}</p>
                        </div>
                        <p class="subtitle" v-if="activeSection === 'new' && !bot.page">{{ $t('dash.bots.pages_subtitle') }}</p>

                        <!--<div class="connected-pages">
                            <div
                                    @click="right"
                                    class="pages-arrow left-arrow"
                                    v-if="scroll == true"
                            >
                                <i class="material-icons">keyboard_arrow_left</i>
                            </div>
                            <div class="linked-pages" :class="{ scrolled: scroll }">
                                <div
                                        class="page"
                                        v-for="(item, index) in linkedPages"
                                        :key="index"
                                        v-show="activeSection === 'new' || (activeSection === 'edit' && bot.page == item.id)"
                                >
                                    <input
                                            type="radio"
                                            :id="`page-index-${index}`"
                                            name="page"
                                            :value="item.id"
                                            v-model="bot.page"
                                            :disabled="!checkLock(item.network)"
                                            @click="addDefaultBotName(item); getHighlightsInstagramList(item)"
                                            :data-qa="'form-bot-page-selector-'+item.network"
                                    />
                                    <div
                                      class="page-wrapper"
                                      :class="{ disabled: !checkLock(item.network)}"
                                    >
                                        <div class="page-content">
                                            <div class="vertical-align">
                                                <page-image-avatar :page="item"/>
                                                <p class="page-name">{{ item.name }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                    @click="left"
                                    class="pages-arrow right-arrow"
                                    v-if="scroll == true"
                            >
                                <i class="material-icons">keyboard_arrow_right</i>
                            </div>
                        </div>-->

                        <template v-if="bot && bot.page">

                            <!-- BOT NAME SECTION -->
                            <div class="table-subtitle">
                                <p>{{ $t('dash.bots.name') }}</p>
                            </div>
                            <p class="subtitle">{{ $t('dash.bots.name_subtitle') }}</p>
                            <div class="title box">
                                <div class="title-item title-wrapper">
                                    <div class="input-wrapper">
                                        <vs-input
                                         @keypress.enter.prevent
                                                vs-size="large"
                                                type="text"
                                                name="name"
                                                class="inputx"
                                                v-bind:placeholder="$t('dash.bots.name_placeholder')"
                                                v-model="bot.name"
                                                v-on:keyup="manualName=true"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- END BOT NAME SECTION -->

                            <div class="table-subtitle" id="sources">
                                <!--<p>{{ $t('dash.bots.botType') }}</p>-->
                                <p>{{ $t('dash.bots.source') }}</p>
                            </div>
                            <p class="subtitle">{{ $t('dash.bots.botType_subtitle') }}</p>

                            <div class="type box post-content bot-type">
                                <div class="display-wrapper">
                                    <div class="thumbnail">
                                        <input
                                                name="radio-sources"
                                                type="radio"
                                                value="custom"
                                                v-model="bot.sourceType"
                                                :disabled="checkEditBotType('custom') || (!checkLock('source_choice') || checkLock('partner'))"
                                                data-qa="form-bot-source-type-custom"
                                        />
                                        <div
                                                class="thumbnail-wrapper"
                                                :class="[{'select': bot.sourceType == 'custom'}]"
                                                :style="{backgroundColor: !checkLock('source_choice') || checkLock('partner') ? 'white' : ''}"
                                        >
                                            <div
                                                    class="thumbnail-content"
                                                    :style="{filter: !checkLock('source_choice') || checkLock('partner') ? 'grayscale(1)' : ''}"
                                            >
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/custom.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.botType_custom') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail">
                                        <input
                                                name="radio-sources"
                                                type="radio"
                                                value="normal"
                                                v-model="bot.sourceType"
                                                :disabled="checkEditBotType('normal')"
                                                data-qa="form-bot-source-type-normal"
                                        />
                                        <div class="thumbnail-wrapper" :class="[{'select': bot.sourceType == 'normal'}]">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/mashup.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.botType_mashup') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail">
                                        <input
                                                name="radio-sources"
                                                type="radio"
                                                value="none"
                                                v-model="bot.sourceType"
                                                @click="manualFrequency"
                                                :disabled="checkEditBotType('none')"
                                                data-qa="form-bot-source-type-none"
                                        />
                                        <div class="thumbnail-wrapper" :class="[{'select': bot.sourceType == 'none'}]">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/none.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.botType_none') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <template v-if="bot.sourceType == 'normal'">
                                <div class="table-subtitle">
                                    <p>{{ $t('dash.bots.topics') }}</p>
                                </div>

                                <p class="subtitle">
                                    {{ $t('dash.bots.topics_subtitle') }}
                                </p>

                                <div
                                        class="topics box"
                                        v-if="this.activeSection !== 'main'"
                                >
                                    <!-- LANGUAGE SELECTOR-->
                                    <div class="topics-item select-wrapper">
                                        <div class="section-subtitle">
                                            <p>{{ $t('dash.bots.topic_language') }}</p>
                                        </div>
                                        <div class="input-wrapper">
                                            <vs-select v-model="bot.topics.lang">
                                                <vs-select-item
                                                        v-for="(item, index) in languages"
                                                        :key="'lang_' + index"
                                                        :value="item.value || 0"
                                                        :text="item.text || ''"
                                                />
                                            </vs-select>
                                        </div>
                                    </div>
                                    <!-- LANGUAGE SELECTOR END-->

                                    <!-- CATEGORY SELECTOR (SERVICE TYPE IN BACKEND)-->
                                    <div class="topics-item theme-wrapper">
                                        <div class="section-subtitle">
                                            <img src="../../../assets/img/icon_check.svg"
                                                 alt="search" />
                                            <p>{{ $t('dash.bots.topic') }}</p>
                                        </div>
                                        <div class="autocomplete-wrapper">
                                            <div class="custom-search">
                                                <autocomplete
                                                        v-if="this.isEditSection"
                                                        :disableInput="false"
                                                        ref="theme"
                                                        :source="themes"
                                                        results-property="items"
                                                        :placeholder="$t('dash.bots.topic_placeholder')"
                                                        :initialDisplay="bot.topics.theme ? bot.topics.theme.name : ''"
                                                        @selected="setTheme"
                                                        @clear="setTheme({})"
                                                ></autocomplete>
                                                <autocomplete
                                                        v-else
                                                        :disableInput="!bot.topics.lang ? true : false"
                                                        ref="theme"
                                                        :source="themes"
                                                        results-property="items"
                                                        :placeholder="$t('dash.bots.topic_placeholder')"
                                                        :initialDisplay="bot.topics.theme ? bot.topics.theme.name : ''"
                                                        @selected="setTheme"
                                                        @clear="setTheme({})"
                                                ></autocomplete>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END CATEGORY SELECTOR -->

                                    <!-- SUB-CATEGORY SELECTOR (CATEGORY TYPE IN BACKEND) -->
                                    <div class="topics-item category-wrapper">
                                        <div class="section-subtitle">
                                            <p>{{ $t('dash.bots.category') }}</p>
                                        </div>
                                        <div class="autocomplete-wrapper">
                                            <div class="custom-search">
                                                <autocomplete
                                                        ref="category"
                                                        :request-headers="authHeaders"
                                                        :source="getTopic"
                                                        :results-display="res => res.name[bot.topics.lang]"
                                                        results-property="categories"
                                                        :placeholder="$t(`dash.bots.category_placeholder${bot.topics.theme ? '' : '_notheme'}`)"
                                                        :initialDisplay="bot.topics.category ? bot.topics.category.name : ''"
                                                        :disableInput="!bot.topics.theme ? true : false"
                                                        @selected="setTopic"
                                                        @clear="setTopic({})"
                                                ></autocomplete>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- END SUB-CATEGORY SELECTOR -->


                                </div>
                            </template>
                  
                            <!-- SOURCES LIST -->
                            <div
                                    class="columns-wrapper"
                                    v-if="
                (this.bot.topics.theme && this.bot.topics.category) ||
                  bot.sourceType == 'custom'"
                            >
                                <div class="columns left-column">
                                    <div class="table-subtitle">
                                        <!--<p>{{ $t('dash.bots.source') }}</p>-->
                                    </div>
                                    <p class="subtitle">{{ $t('dash.bots.sources_subtitle') }}</p>

                                    <!--<div class="add-source subtitle" v-if="bot.sourceType == 'custom'">
                                      <Tooltip v-if="checkLock('sources') || checkLock('partner')" :text="$t('dash.locked')" position="top">
                                        <vs-button
                                          class="btn-img btn-large"
                                          color="#2F1937"
                                          size="large"
                                          @click="add=true"
                                          vs-type="filled"
                                          disabled
                                        >
                                          <p>{{$t('dash.sources.add')}}</p>
                                          <img class="icon-white" src="../../../assets/img/icon_rss.svg" alt="rss">
                                        </vs-button>
                                        <span>&nbsp;</span>
                                      </Tooltip>
                                      <vs-button
                                        v-if="checkLock('sources') || checkLock('partner')"
                                        @click="goToSettings()"
                                        class="btn-large btn-img"
                                        color="#2F1937"
                                        vs-type="filled"
                                      >
                                        <p>{{$t('dash.button.changeplan')}}</p>
                                        <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
                                      </vs-button>
                                      <vs-button
                                        v-if="!checkLock('sources') && !checkLock('partner')"
                                        class="btn-img btn-large"
                                        color="#2F1937"
                                        size="large"
                                        @click="addSource=true"
                                        vs-type="filled"
                                      >
                                        <p>{{$t('dash.sources.add')}}</p>
                                        <img class="icon-white" src="../../../assets/img/icon_rss.svg" alt="rss">
                                      </vs-button>
                                      <vs-popup class="overlay sources-overlay" title="Source" :active.sync="addSource" v-if="!checkLock('sources') && !checkLock('partner')">
                                        <component-sources-overlay
                                          :mode="'new'"
                                          :editSource="''"
                                          @close-source-form="cleanSourceData"
                                          @fetchSources="fetchSourcesNew"
                                        >
                                        </component-sources-overlay>
                                      </vs-popup>
                                    </div>-->  

                                    <div class="source">
                                        <div class="box source-content">
                                            <div class="filters-wrapper">
                                                <div
                                                        v-if="bot.sourceType == 'normal'"
                                                        class="input-wrapper search-input"
                                                        :class="[allSourcesBtnSelect ? 'disabled' : '']"
                                                >
                                                    <img
                                                            src="../../../assets/img/icon_search_pink.png"
                                                            alt="search"
                                                    />
                                                    <vs-input
                                                     @keypress.enter.prevent
                                                            :disabled="allSourcesBtnSelect"
                                                            vs-size="large"
                                                            color="#B20564"
                                                            type="text"
                                                            name="search"
                                                            class="inputx"
                                                            :placeholder="$t('dash.bots.source_placeholder')"
                                                            v-model="sources.search"
                                                            @input="filterList"
                                                    />
                                                </div>
                                                <div
                                                        class="input-wrapper filter-input"
                                                        v-if="bot.sourceType === 'normal'"
                                                >
                                                    <vs-button
                                                            class="add-btn btn-img"
                                                            color="#2F1937"
                                                            vs-type="filled"
                                                            size="large"
                                                            @click.prevent="toggleAllSources()"
                                                    >
                                                        <p v-if="allSourcesBtnSelect">
                                                            {{ $t('dash.bots.remove_all_sources') }}
                                                        </p>
                                                        <p v-else>{{ $t('dash.bots.add_all_sources')
                                                            }}</p>
                                                    </vs-button>
                                                </div>
                                                <!--div class="input-wrapper filter-input">
                                                  <vs-select v-model="sources.filter">
                                                    <vs-select-item
                                                      :key="index"
                                                      :vs-value="item.value"
                                                      :vs-text="item.text"
                                                      v-for="(item,index) in sources.filters"
                                                    />
                                                  </vs-select>
                                                </div>
                                                <div class="input-wrapper order-input">
                                                  <vs-select v-model="sources.order" @change="sort()">
                                                    <vs-select-item
                                                      :key="index"
                                                      :vs-value="index"
                                                      :vs-text="index"
                                                      v-for="(item,index) in sources.orders"
                                                    />
                                                  </vs-select>
                                                </div-->
                                            </div>

                                            <div class="source-container">
                                                <div class="source-wrapper scrollable">
                                                    <div
                                                            class="source-item"
                                                            v-for="(source, index) in getSourcesList.slice().reverse()"
                                                            :key="index"
                                                            :class="{
                                                              selected:
                                                                selectedSources.includes(source.uid || source.id) ||
                                                                allSourcesBtnSelect
                                                            }"
                                                    >
                                                        <vs-avatar size="30px" :src="source.logo" />
                                                        <p class="source-title">{{ source.name }}</p>
                                                        <template v-if="!allSourcesBtnSelect">
                                                            <vs-button
                                                                    v-if="!selectedSources.includes(source.uid || source.id)"
                                                                    class="add-btn btn-img"
                                                                    color="#2F1937"
                                                                    vs-type="filled"
                                                                    size="large"
                                                                    type="submit"
                                                                    @click.prevent="bot.sources.push(source)"
                                                            >
                                                                <p>{{$t('dash.sources.select')}}</p>
                                                                <!--<img
                                                                        src="../../../assets/img/icon_more.svg"
                                                                        alt="more"
                                                                />-->
                                                            </vs-button>

                                                            <button
                                                                    v-else
                                                                    class="remove-btn"
                                                                    @click.prevent="removeSource(source)"
                                                            >
                                                                <i class="material-icons">close</i>
                                                            </button>
                                                        </template>
                                                    </div>
                                                    
                                                </div>
                                                    <div class="add-source source-item" v-if="bot.sourceType == 'custom'">
                                                      <Tooltip v-if="checkLock('sources') || checkLock('partner') || newSources.length >= checkLock('sources_limit')" :text="$t('dash.locked')" position="top">
                                                        <vs-button
                                                          class="btn-img btn-large"
                                                          color="#2F1937"
                                                          size="large"
                                                          @click="add=true"
                                                          vs-type="filled"
                                                          disabled
                                                        >
                                                          <p>{{$t('dash.sources.add')}}</p>
                                                          <img class="icon-white" src="../../../assets/img/icon_rss.svg" alt="rss">
                                                        </vs-button>
                                                        <span>&nbsp;</span>
                                                      </Tooltip>
                                                      <vs-button
                                                        v-if="checkLock('sources') || checkLock('partner') || newSources.length >= checkLock('sources_limit')"
                                                        @click="goToSettings()"
                                                        class="btn-large btn-img"
                                                        color="#2F1937"
                                                        vs-type="filled"
                                                      >
                                                        <p>{{$t('dash.button.changeplan')}}</p>
                                                        <img src="../../../assets/img/icon_unlock.svg" alt="unlock">
                                                      </vs-button>
                                                      <vs-button
                                                        v-if="!checkLock('sources') && !checkLock('partner') && this.newSources.length < checkLock('sources_limit')"
                                                        class="btn-img btn-large"
                                                        color="#2F1937"
                                                        size="large"
                                                        @click="addSource=true"
                                                        vs-type="filled"
                                                        data-qa="form-bot-add-source"
                                                      >
                                                        <p>{{$t('dash.sources.add')}}</p>
                                                        <img class="icon-white" src="../../../assets/img/icon_rss.svg" alt="rss">
                                                      </vs-button>
                                                      <vs-popup class="overlay sources-overlay" title="Source" :active.sync="addSource" >
                                                        <component-sources-overlay
                                                          :mode="'new'"
                                                          :editSource="''"
                                                          @close-source-form="cleanSourceData"
                                                          @fetchSources="fetchSourcesNew"
                                                        >
                                                        </component-sources-overlay>
                                                      </vs-popup>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns right-column">
                                    <!--<div class="table-subtitle">
                                        <p>{{ $t('dash.bots.add_hashtag') }}</p>
                                    </div>
                                    <p class="subtitle">
                                        {{ $t('dash.bots.add_hashtag_subtitle') }}
                                    </p>

                                    <div class="hashtags box">
                                        <vs-textarea v-model="bot.hashtag"
                                          :placeholder="$t('dash.bots.hashtags_placeholder')" />
                                    </div>-->

                                    <div class="table-subtitle">
                                        <p>{{ $t('dash.bots.inclusion_tags') }}</p>
                                    </div>
                                    <p class="subtitle">
                                        {{ $t('dash.bots.inclusion_tags_subtitle') }}
                                    </p>
                                    <div class="blacklists box">
                                        <vue-tags-input
                                                v-model="bot.inclusion.tag"
                                                :tags="bot.inclusion.tags"
                                                :placeholder="$t('dash.bots.inclusion_placeholder')"
                                                @tags-changed="newTags => (bot.inclusion.tags = newTags)"
                                                @before-deleting-tag="newTag => removeCorrespondance(null, 'inclusion', newTag)"
                                        ></vue-tags-input>
                                    </div>

                                    <div class="table-subtitle">
                                        <p>{{ $t('dash.bots.blacklist') }}</p>
                                    </div>
                                    <p class="subtitle">{{ $t('dash.bots.blacklist_subtitle') }}</p>

                                    <div class="blacklists box">
                                        <div class="section-subtitle">
                                            <img
                                                    src="../../../assets/img/icon_blacklist.svg"
                                                    alt="Mashup logo"
                                            />
                                            <p>{{ $t('dash.bots.blacklist_add') }}</p>
                                        </div>
                                        <vue-tags-input
                                                v-model="bot.exclusion.tag"
                                                :tags="bot.exclusion.tags"
                                                :autocomplete-items="filteredItems"
                                                :placeholder="$t('dash.bots.blacklist_placeholder')"
                                                @tags-changed="newTags => (bot.exclusion.tags = newTags)"
                                                @before-deleting-tag="newTag => removeCorrespondance(null, 'exclusion', newTag)"
                                        ></vue-tags-input>
                                    </div>
                                </div>
                            </div>
                            <!-- SOURCES LIST END-->
                            <!-- EMPTY SOURCES LIST -->
                            <div
                                    class="columns-wrapper"
                                    v-else-if="bot.sourceType != 'none'">

                                <div class="columns left-column">
                                    <div class="table-subtitle">
                                        <p>{{ $t('dash.bots.source') }}</p>
                                    </div>
                                    <p class="subtitle">{{ $t('dash.bots.sources_subtitle_no_topic') }}</p>
                                </div>
                            </div>
                            <!-- EMPTY SOURCES LIST END-->

                            <!-- <component-conciergerie :page="this.selectedPage" :pages="pages"></component-conciergerie> -->

                            <div v-if="(this.selectedPage.network === 'linkedin' && activeLinkedinCredentials) || ( this.selectedPage.network === 'instagram' && activeInstagramStories)" id="connection">
                              <div class="table-subtitle">
                                <p>{{ $t('dash.bots.connection') }}</p>
                              </div>
                              <p class="subtitle">{{ $t('dash.bots.connection_subtitle') }}</p>
                              <div v-if="linkedinConnected === 'connected'">
                                <p class="connect-success">{{$t('dash.bots.connected_direct')}}</p>
                                <p class="connect-warning" v-if="usernamePageDiff">{{$t("dash.bots.username_diff_insta").replace("d'utilisateur", usernamePageDiff) + " " +selectedPage.name}}</p>
                                <vs-button v-if="!connectionReturn" class="modify-btn-linkedin" @click="() => linkedinModify=true">Modifier</vs-button>
                                <Tooltip v-if="!connectionReturn || usernamePageDiff" :text="$t('dash.pages.disconnect_conciergerie')" position="right">
                                  <vs-button
                                    @click="disconnectConciergerie(selectedPage.id)" class="disconnect-conciergerie">
                                    <p>{{$t("dash.header.nav.logout")}}</p>
                                    <!-- <p>{{$t("dash.pages.disconnect_conciergerie")}}</p> -->
                                  </vs-button>
                                  <span>&nbsp;</span>
                                </Tooltip>
                              </div>
                              <div v-else class="conciergerie-instruction">
                                <h3 v-if="['linkedin'].includes(selectedPage.network)" class="conciergerie-instruction-title bot-version">{{$t('dash.bots.connection_method_1')}}</h3>
                                <div v-if="['linkedin'].includes(selectedPage.network)" class="conciergerie-instruction-method method-1 bot-version">
                                  <vs-button v-if="!extension" :style="{width: '250px'}" @click="useExtension">{{$t(`dash.bots.connection_open_extension`)}}</vs-button>
                                  <p v-if="!extension">{{$t('dash.bots.extension_explication_1')}}</p>
                                  <p  v-if="!extension" v-html="$t('dash.bots.extension_explication_2')"></p>
                                  <p v-else v-html="$t('dash.bots.extension_explication_3')"></p>
                                </div>
                                <h3 v-if="['linkedin'].includes(selectedPage.network)" class="conciergerie-instruction-title bot-version">{{$t('dash.bots.connection_method_2')}}</h3>
                                <div class="conciergerie-instruction-method method-2" :style="{display: 'flex', gap: '30px', marginBottom: '20px'}">
                                  <vs-input :label="$t(`dash.bots.connection_email${this.selectedPage.network === 'instagram' ? '_username' : ''}`)" :placeholder="$t(`dash.bots.connection_email${this.selectedPage.network === 'instagram' ? '_username' : ''}`)" v-model="linkedinUsername" @keypress.enter.prevent="connectLinkedin" @submit.prevent="connectLinkedin"/>
                                  <vs-input :type="showPass ? 'text' : 'password'" :label="$t('dash.bots.connection_password')" :placeholder="$t('dash.bots.connection_password')" v-model="linkedinPassword" @submit.prevent="connectLinkedin" @keypress.enter.prevent="connectLinkedin"/>
                                  <vs-button class="btn-eye" type="fill" 
                                  @click="showPass = !showPass"
                                  :icon="showPass ? 'visibility_off' : 'visibility'"
                                ></vs-button>
                                </div>
                                <!-- <p class="warning-two-auth" v-if="['linkedin', 'instagram'].includes(this.selectedPage.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
                                <p class="warning-two-auth" v-if="['instagram'].includes(this.selectedPage.network)">{{ $t('dash.bots.warning_two_auth_insta')}}</p> -->
                                <p class="warning-two-auth" v-if="['linkedin'].includes(this.selectedPage.network)">{{ $t('dash.bots.warning_two_auth')}}</p>
                                <!-- <p class="warning-two-auth" v-if="['instagram'].includes(this.selectedPage.network)">{{ $t('dash.bots.warning_no_two_auth')}}</p> -->
                                <div class="username-conciergerie-diff" v-if="selectedPage.network === 'instagram' && instagramPagesUsernames.filter(e => e.name !== selectedPage.name).map(e => e.username).includes(linkedinUsername)">
                                  <p >{{$t("dash.bots.username_used_insta") + instagramPagesUsernames.find(e => e.username === linkedinUsername).name}}</p>
                                  <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="() => linkedinUsername =''" color="primary" type="filled">{{$t("dash.button.cancel")}}</vs-button>
                                  ou
                                  <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
                                </div>
                                <div class="username-conciergerie-diff" v-else-if="selectedPage.network === 'instagram' && linkedinUsername && selectedPage.name.trim() !== linkedinUsername.trim()">
                                  <p >{{$t("dash.bots.username_diff_insta")}}</p>
                                  <vs-button :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="connectLinkedin" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn1") + linkedinUsername}}</vs-button>
                                  ou
                                  <vs-button style="text-transform: none;" :disabled="!linkedinUsername || !linkedinPassword" id="linkedin-direct-loading" class="vs-con-loading__container replace-username-btn" @click="() => connectLinkedin(true)" color="primary" type="filled">{{$t("dash.bots.username_diff_insta_btn2") + selectedPage.name}}</vs-button>
                                </div>
                                <vs-button v-else id="linkedin-direct-loading" class="vs-con-loading__container" @click="connectLinkedin" color="primary" type="filled">{{ $t('dash.bots.connect_direct') }}</vs-button>
                              </div>
                            </div>

                            <div class="column">
                              <div class="left">
                                <div class="table-subtitle">
                                    <p>{{ $t('dash.bots.add_hashtag') }}</p>
                                </div>
                                <p class="subtitle">{{ $t('dash.bots.add_hashtag_subtitle') }}</p>
                                <div class="hashtags prefix box" v-click-outside="hideEmojiPickerPrefix">
                                  <div class="textarea-emoji-picker" >
                                    <picker
                                      :data="emojiIndex"
                                      v-show="showEmojiPickerPrefix"
                                      title="Pick your emoji..."
                                      emoji="point_up"
                                      @select="addEmojiPrefix"
                                    />
                                    <span
                                      class="emoji-trigger"
                                      :class="{ 'triggered': showEmojiPickerPrefix }"
                                      @click="toggleEmojiPicker('prefix')"
                                    >
                                      <svg
                                        style="width:20px;height:20px"
                                        viewBox="0 0 24 24"
                                      >
                                        <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                                      </svg>
                                    </span>
                                    <vs-textarea v-model="bot.hashtagPrefix"
                                      :label="$t('dash.bots.hashtags_prefix_label')"
                                      id="hashtag-prefix"
                                      :placeholder="$t('dash.bots.hashtags_prefix_placeholder')"
                                      ref="inputHashtagPrefix"
                                      data-qa="form-bot-add-prefix"
                                    />
                                  </div>
                                </div>
                                <div class="hashtags suffix box" v-click-outside="hideEmojiPickerSuffix">
                                  <div class="textarea-emoji-picker">
                                    <picker
                                      :data="emojiIndex"
                                      v-show="showEmojiPickerSuffix"
                                      title="Pick your emoji..."
                                      emoji="point_up"
                                      @select="addEmojiSuffix"
                                    />
                                    <span
                                      class="emoji-trigger"
                                      :class="{ 'triggered': showEmojiPickerSuffix }"
                                      @click="toggleEmojiPicker('suffix')"
                                    >
                                      <svg
                                        style="width:20px;height:20px"
                                        viewBox="0 0 24 24"
                                      >
                                        <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                                      </svg>
                                    </span>
                                    <vs-textarea v-model="bot.hashtag"
                                      :label="$t('dash.bots.hashtags_suffix_label')"
                                      id="hashtag-suffix"
                                      :placeholder="$t('dash.bots.hashtags_suffix_placeholder')"
                                      ref="inputHashtagSuffix"
                                      data-qa="form-bot-add-suffix"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="right" v-if="!getBoardPagePinterest">
                                <div class="table-subtitle">
                                    <p v-if="['twitter', 'facebook', 'linkedin', 'instagram'].includes(selectedPage.network)">{{ $t('dash.bots.mentions_hashtagsAuto') }}</p>
                                    <p v-else>{{ $t('dash.bots.hashtagsAuto') }}</p>
                                </div>
                                <p class="subtitle" v-if="['twitter', 'facebook', 'linkedin', 'instagram'].includes(selectedPage.network)">
                                  <span v-if="['facebook', 'linkedin', 'instagram'].includes(selectedPage.network)">(Beta)</span>
                                  {{ $t('dash.bots.mentions_subtitle') }}
                                  <span v-if="bot.mentions.length > 0 && bot.mentions[0].mention != ''">({{ bot.mentions.length }} mentions)</span>
                                </p>
                                <div class="mentions" v-if="['twitter', 'facebook', 'linkedin', 'instagram'].includes(selectedPage.network)">
                                  <ul>
                                    <li class="row" v-for="(values, key) in bot.mentions" :key="key">        
                                      <div class="mention-content" 
                                        v-click-outside="closeAutoMentions"
                                      >
                                        <vs-input
                                         @keypress.enter.prevent
                                          vs-size="large"
                                          type="text"
                                          name="mention"
                                          class="inputx mention"
                                          icon="@"
                                          v-bind:placeholder="$t(`dash.bots.mention_${['linkedin', 'instagram'].includes(selectedPage.network) && linkedinConnected !== 'connected' ? 'url' : 'name'}_placeholder`)"
                                          v-model="values.mention"
                                          v-on:focus="showAutoMentions(key)"
                                          v-on:keyup="searchMentions(key)"
                                          data-qa="form-bot-add-mention"
                                        />
                                        <!--<div class="auto-mentions" v-if="autoMentions[key] && autoMentions[key].length > 0" v-click-outside="closeAutoMentions()">-->
                                        <div class="auto-mentions row box" :class="selectedPage.network" data-qa="form-bot-select-auto-mentions" v-if="openAutoMentions && autoMentions[key] && autoMentions[key].length > 0 && values.mention.length >= 2" :key="`${key}-${values.mention}`">
                                          <ul>
                                            <li v-for="(mention, index) in autoMentions[key]" :key="index">
                                              <div @click="replaceMention(key, mention)">                                                
                                                <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                                                <span class="image" v-else></span>
                                                <div class="content">
                                                  <p class="name">{{ mention.name }}</p>
                                                  <img alt="verified account" src="../../../assets/img/validated-twitter.png" v-if="selectedPage.network == 'twitter'"/>
                                                  <p class="screen_name id" v-if="selectedPage.network == 'facebook'">{{ mention.id }}</p>
                                                  <p class="screen_name" v-else>@{{ selectedPage.network == 'twitter' ? mention.screen_name : (selectedPage.network == 'instagram' ? mention.id : mention.name) }}</p>
                                                  <p class="description" v-if="selectedPage.network == 'twitter'">{{ mention.description }}</p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <vue-tags-input
                                        class="correspondences"
                                        v-model="values.correspondence"
                                        :tags="values.correspondences"
                                        :placeholder="$t('dash.bots.mention_correspondences_placeholder')"
                                        @before-adding-tag="newTag => checkAndAddCorrespondance(key, 'mention', newTag)"
                                        @before-deleting-tag="newTag => removeCorrespondance(key, 'mention', newTag)"
                                        data-qa="form-bot-add-mention-correspondance"
                                      ></vue-tags-input>
                                      <vs-button color="#303030" @click="removeMention(key)" icon="remove" class="remove"></vs-button>
                                    </li>
                                  </ul>
                                  <vs-button @click="addMention" color="#303030">
                                    {{ $t('dash.bots.mentions.add.new') }}
                                  </vs-button>
                                </div>

                                <p class="subtitle">
                                  {{ $t('dash.bots.hashtagsAuto_subtitle') }}
                                  <span v-if="bot.hashtagsAuto.length > 0 && bot.hashtagsAuto[0].hashtag != ''">({{ bot.hashtagsAuto.length }} #hashtags)</span>
                                </p>
                                <div class="hashtags-auto">
                                  <ul>
                                    <li class="row" v-for="(values, key) in bot.hashtagsAuto" :key="key">        
                                      <div class="hashtag-content">
                                        <vs-input
                                         @keypress.enter.prevent
                                          vs-size="large"
                                          type="text"
                                          name="hashtag"
                                          class="inputx hashtag"
                                          icon="#"
                                          v-bind:placeholder="$t('dash.bots.hashtags_name_placeholder')"
                                          v-model="values.hashtag"
                                          data-qa="form-bot-add-hashtag"
                                        />
                                      </div>
                                      <vue-tags-input
                                        class="correspondences"
                                        v-model="values.correspondence"
                                        :tags="values.correspondences"
                                        :placeholder="$t('dash.bots.hashtag_correspondences_placeholder')"
                                        @before-adding-tag="newTag => checkAndAddCorrespondance(key, 'hashtag', newTag)"
                                        @before-deleting-tag="newTag => removeCorrespondance(key, 'hashtag', newTag)"
                                        data-qa="form-bot-add-hashtag-correspondance"
                                      ></vue-tags-input>
                                      <vs-button color="#303030" @click="removeHashtag(key)" icon="remove" class="remove"></vs-button>
                                    </li>
                                  </ul>
                                  <vs-button @click="addHashtag" color="#303030">
                                    {{ $t('dash.bots.hashtags.add.new') }}
                                  </vs-button>
                                </div>
                              </div>
                            </div>
                            <!-- <div v-if="!getBoardPagePinterest"> -->
                            <div>
                              <div class="table-subtitle">
                                  <p>{{ $t('dash.bots.utm') }}</p>
                              </div>
                              <p class="subtitle">{{ $t('dash.bots.utm_subtitle') }}</p>

                              <div class="title box">
                                  <div class="title-item title-wrapper">
                                      <div class="input-wrapper">
                                          <vs-input
                                          @keypress.enter.prevent
                                                  disabled
                                                  vs-size="large"
                                                  type="text"
                                                  name="utm"
                                                  class="inputx"
                                                  v-bind:placeholder="$t('dash.bots.utm_placeholder')"
                                                  v-model="bot.utm"
                                          />
                                      </div>
                                  </div>
                              </div>
                              <div class="title box utm">
                                  <div class="title-item title-wrapper">
                                      <div class="input-wrapper">
                                        <vs-row>
                                          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                                            <vs-input
                                            @keypress.enter.prevent
                                                  label="utm_campaign"
                                                  type="text"
                                                  name="campaign"
                                                  class="inputx"
                                                  v-bind:placeholder="$t('dash.bots.utm_placeholder')"
                                                  :value="bot.utmCampaign"
                                                  @change="changeUtmValue('utm_campaign', $event)"
                                            />
                                          </vs-col>
                                          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                                            <vs-input
                                            @keypress.enter.prevent
                                                  label="utm_medium"
                                                  type="text"
                                                  name="medium"
                                                  class="inputx"
                                                  v-bind:placeholder="$t('dash.bots.utm_placeholder')"
                                                  :value="bot.utmMedium"
                                                  @change="changeUtmValue('utm_medium', $event)"
                                            />
                                          </vs-col>
                                          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
                                            <vs-input
                                            @keypress.enter.prevent
                                                  label="utm_source"
                                                  type="text"
                                                  name="source"
                                                  class="inputx"
                                                  v-bind:placeholder="$t('dash.bots.utm_placeholder')"
                                                  :value="bot.utmSource"
                                                  data-qa="form-bot-utm-source"
                                                  @change="changeUtmValue('utm_source', $event)"
                                            />
                                          </vs-col>
                                        </vs-row>
                                      </div>
                                  </div>
                              </div>
                            </div>

                            <div v-if="['twitter', 'instagram', 'facebook', 'linkedin'].includes(selectedPage.network)" class="post-type">
                              <div class="table-subtitle">
                                <p>Type de post</p>
                              </div>
                              <p class="subtitle">
                                Sélectionnez le type de post que vous souhaitez poster 
                              </p>

                              <div class="post-content" v-if="!['google', 'telegram'].includes(selectedPage.network)">
                                <div class="display-wrapper">
                                    <div class="thumbnail">
                                        <input
                                                type="radio"
                                                name="post-mode"
                                                value="standard"
                                                v-model="bot.posts.mode"
                                                @change="_ => {$forceUpdate(); modeInsta = bot.posts.mode}"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper thumbnail-img-wrapper-instagram">
                                                        <img
                                                                src="../../../assets/img/input/instagram-post.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>Standard</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail"  v-if="selectedPage.network !== 'instagram'">
                                        <input
                                                type="radio"
                                                name="post-mode"
                                                value="image"
                                                v-model="bot.posts.mode"
                                                @change="_ => {$forceUpdate(); modeInsta = bot.posts.mode}"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper thumbnail-img-wrapper-instagram">
                                                        <img
                                                                src="../../../assets/img/input/instagram-post.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>Image</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail"  v-if="selectedPage.network === 'instagram' && linkedinConnected === 'connected' && activeInstagramStories">
                                        <input
                                                type="radio"
                                                name="post-mode"
                                                value="story"
                                                v-model="bot.posts.mode"
                                                @change="_ => {$forceUpdate(); modeInsta = bot.posts.mode}"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper thumbnail-img-wrapper-instagram">
                                                        <img
                                                                src="../../../assets/img/input/instagram-story.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>Story Instagram</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                              </div>
                              <!-- <div class="story-credentials" v-if="bot.posts.mode === 'story'">
                                <div class="table-subtitle">
                                  <p>Informations de connexion</p>
                                </div>
                                <p class="subtitle" v-if="!selectedPage.instagram_username">
                                  Veuillez saisir les informations de connexion de votre compte instagram. <br>
                                  Ces informations seront chiffrées et seulement utilisées pour poster automatiquement vos stories. 
                                </p>
                                <p class="subtitle" v-else>Vous avez déjà entré vos identifiants pour cette page. Souhaitez vous les modifier ?</p>

                                <vs-row vs-w="15" v-if="!selectedPage.instagram_username || changeCredential">
                                  <vs-col vs-type="flex" vs-w="2">
                                    <vs-input label="Nom d'utilisateur ou Email" placeholder="" v-model="bot.instagram.credentials.username"/>
                                  </vs-col>
                                  <vs-col vs-type="flex" vs-w="2">
                                    <vs-input type="password" label="Mot de passe" placeholder="" v-model="bot.instagram.credentials.password"/>
                                  </vs-col>
                                  <vs-button v-if="changeCredential" type="flat" @click="() => {
                                    changeCredential = false; 
                                    bot.instagram.credentials = {};
                                  }">
                                    Annuler
                                  </vs-button>
                                </vs-row>
                                <vs-button v-else @click="() => {
                                  changeCredential = true; 
                                  bot.instagram.credentials.username = selectedPage.instagram_username;
                                }">
                                  Modifier mes identifiants Instagram
                                </vs-button>

                              </div> -->

                              <div v-if="bot.posts.mode === 'story'" class="story-template">
                                <div class="table-subtitle">
                                    <p>Configurer son modèle</p>
                                </div>
                                <div class="limit">
                                    <div class="limit-wrapper">
                                        <vs-radio
                                                :class="{ active: templateMode === 'manual' }"
                                                v-model="templateMode"
                                                vs-value="manual"
                                        >
                                            Personnalisé
                                        </vs-radio>
                                        <vs-radio
                                                :class="{ active: templateMode == 'auto' }"
                                                v-model="templateMode"
                                                vs-value="auto"
                                        >
                                            Prédéfini
                                        </vs-radio>
                                    </div>
                                </div>
                                <div class="template-config">
                                  <!-- <div v-if="templateMode === 'manual'">
                                    <div class="table-subtitle-template">
                                      <p>Personnaliser son modèle : </p>
                                    </div>
                                    <vs-select label="Image" v-model="templateStory.image">
                                      <vs-select-item text="Ajuster" value="contain"/>
                                      <vs-select-item text="Remplir tout l’espace" value="fill"/>
                                    </vs-select>
                                    <div class="template-text">
                                      <label>Texte : </label>
                                      <vs-radio v-model="templateStory.text" vs-name="storyTemplateText" vs-value="top">Haut</vs-radio>
                                      <vs-radio v-model="templateStory.text" vs-name="storyTemplateText" vs-value="middle">Milieu</vs-radio>
                                      <vs-radio v-model="templateStory.text" vs-name="storyTemplateText" vs-value="bottom">Bas</vs-radio>
                                    </div>
                                  </div>

                                  <div v-if="templateMode === 'manual'" class="template-preview">
                                    <img :style="`object-fit: ${templateStory.image === 'fill' ? 'cover' : 'contain'}`" src="../../../assets/img/template_image.jpg" alt="">
                                    <p :style="`top: ${templateStory.text === 'top' ? 20 : templateStory.text === 'bottom' ? 80 : 50}%`">
                                      {{bot.hashtagPrefix + ' Texte de template ' + bot.hashtag}}
                                    </p>
                                  </div> -->
                                  <component-template-maker :configuration="templateStory.configuration" ref="templateMaker" v-if="templateMode === 'manual'"/>
                                  

                                  <div v-else>
                                    <div class="table-subtitle-template">
                                      <p>Choisir un modèle : </p>
                                    </div>
                                    <div class="template-preview-auto">
                                      <label v-if="selectedPage.name === 'nextplzofficiel'" class="possible-template">
                                        <input v-model="templateStory.predefined" type="radio" name="templateChoice" value="template_nextplz" checked>
                                        <img src="../../../assets/img/template_story_nextplz.png" alt="Template NextPLZ">
                                        <p :style="`top: 20%`">
                                          {{bot.hashtagPrefix + ' Texte de template ' + bot.hashtag}}
                                        </p>
                                      </label>
                                      <label v-else class="possible-template">
                                        <input v-model="templateStory.predefined" type="radio" name="templateChoice" value="template1" checked>
                                        <img src="../../../assets/img/template_story_1.png" alt="Template 1">
                                        <p :style="`top: 20%`">
                                          {{bot.hashtagPrefix + ' Texte de template ' + bot.hashtag}}
                                        </p>
                                      </label>
                                      <label class="possible-template">
                                        <input v-model="templateStory.predefined" type="radio" name="templateChoice" value="template2" checked>
                                        <img src="../../../assets/img/template_story_2.jpg" alt="Template 2">
                                        <p :style="`top: 20%`">
                                          {{bot.hashtagPrefix + ' Texte de template ' + bot.hashtag}}
                                        </p>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="bot.posts.mode === 'story'" class="story-highlight">
                                <p>Voulez vous mettre vos stories à la une ?</p>
                                <vs-radio class="input-no" v-model="templateStory.highlight" vs-name="storyTemplateHighlight" :vs-value="null">Non, simplement ajouter la story</vs-radio>
                                <div class="highlights-wrapper">
                                  <label v-for="(item, idx) in highlightsPage" :key="item.title" class="highlight" :style="templateStory.highlight === item.title && 'color: #B20564;'">
                                    <vs-radio class="hidden" v-model="templateStory.highlight" vs-name="storyTemplateHighlight" :vs-value="item.title">
                                    </vs-radio>
                                    <img :src="item.img" :alt="`highlight-${idx}`" :class="templateStory.highlight === item.title && 'selected-highlight'">
                                    {{item.title}}
                                  </label>
                                  <label class="highlight" for="addHighlight">
                                    <vs-radio id="addHighlight" class="hidden" v-model="templateStory.highlight" vs-name="storyTemplateHighlight" vs-value="__new_highlight__">
                                    </vs-radio>
                                    <p style="font-size: 0.8rem">Créer une nouvelle catégorie</p>
                                    <img src="../../../assets/img/template_image.jpg" :alt="`highlight-new`" :class="templateStory.highlight === '__new_highlight__' && 'selected-highlight'">
                                    <vs-input  @keypress.enter.prevent v-model="newHighlight" :danger="!isValidHightlight" danger-text="Le nom n'est pas valide"></vs-input>
                                  </label>
                                </div>
                              </div>


                            </div>

                            <div class="share-story" v-if="bot.posts.mode == 'standard' && ['instagram'].includes(selectedPage.network) && linkedinConnected === 'connected' && activeInstagramStories">
                              <vs-checkbox :checked="bot.afterAutoPost.story && bot.afterAutoPost.story.shared" class="share-story-box" @change="addSharedStory">{{ $t('dash.bots.shared_story') }}</vs-checkbox>
                            </div>


                            <div class="table-subtitle" v-if="!getBoardPagePinterest">
                                <p>{{ $t('dash.bots.post_content') }}</p>
                            </div>
                            <p class="subtitle" v-if="!getBoardPagePinterest">{{ $t('dash.bots.post_content_subtitle') }}</p>

                            <div class="post-content" v-if="!getBoardPagePinterest">
                                <!--<div class="content-wrapper">
                                    <div class="thumbnail">
                                        <input
                                                type="checkbox"
                                                name="content"
                                                v-model="bot.posts.content"
                                                value="text"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/text-only.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail">
                                        <input
                                                type="checkbox"
                                                name="content"
                                                v-model="bot.posts.content"
                                                value="photo"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/text-img.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text_image') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="thumbnail">
                                        <input
                                                type="checkbox"
                                                name="content"
                                                v-model="bot.posts.content"
                                                value="video"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/text-video.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text_video') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>-->

                                <div class="display-wrapper">
                                    <div class="thumbnail">
                                        <input
                                                type="radio"
                                                name="content"
                                                value="title"
                                                v-model="bot.posts.display"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/text-title.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text_title') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="thumbnail">
                                        <input
                                                type="radio"
                                                name="content"
                                                value="description"
                                                v-model="bot.posts.display"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/text-desc.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text_desc') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="thumbnail" v-if="bot.posts.mode == 'standard'">
                                        <input
                                                type="radio"
                                                name="content"
                                                value="none"
                                                v-model="bot.posts.display"
                                        />
                                        <div class="thumbnail-wrapper">
                                            <div class="thumbnail-content">
                                                <div class="vertical-align">
                                                    <div class="thumbnail-img-wrapper">
                                                        <img
                                                                src="../../../assets/img/input/no-text.svg"
                                                                alt="txt"
                                                        />
                                                    </div>
                                                    <div class="thumbnail-name">
                                                        <p>{{ $t('dash.bots.post_text_snippet')
                                                            }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                              <div v-if="getBoardPagePinterest">
                                    <div class="table-subtitle">
                                <p>{{ $t('dash.bots.board_title') }}</p>
                            </div>
                            <p class="subtitle">{{ $t('dash.bots.board_subtitle') }}</p>
                                <div class="title-item title-wrapper">
                                    <div class="input-wrapper" style="display:flex;">

                             <!--   <div class="highlights-wrapper">
                                  <label v-for="(item, idx) in boards.board.items" :value="item"  class="highlight" :style="templateStory.highlight === item.title && 'color: #B20564;'">
                                    <vs-radio class="hidden" v-model="boardSelected" vs-name="boardSelected" :vs-value="item.name">
                                    </vs-radio>
                                    <img :src="item.img" :alt="`highlight-${idx}`" :class="templateStory.highlight === item.title && 'selected-highlight'">
                                    {{item.title}}
                                  </label>
                                  <label class="highlight" for="addHighlight">
                                    <vs-radio id="addHighlight" class="hidden" v-model="templateStory.highlight" vs-name="storyTemplateHighlight" vs-value="__new_highlight__">
                                    </vs-radio>
                                    <p style="font-size: 0.8rem">Créer une nouvelle catégorie</p>
                                    <img src="../../../assets/img/template_image.jpg" :alt="`highlight-new`" :class="templateStory.highlight === '__new_highlight__' && 'selected-highlight'">
                                    <vs-input v-model="newHighlight" :danger="!isValidHightlight" danger-text="Le nom n'est pas valide"></vs-input>
                                  </label>
                                </div>-->




                                          <select class="selectboard" v-model="boardSelected" v-if="boards && boards.board">
                                            <option v-for="(item,index) in boards.board.items" :value="item" :key="index">
                                              {{ item.name }}
                                            </option>
                                          </select>

                                            <vs-input class="newboard" placeholder="" v-model="newBoardName"  @keypress.enter.prevent/> 
                                            <vs-button
                                            class="page-btn newboardbutton"
                                            vs-type="filled"
                                            color="#303030"
                                            @click.prevent="newBoardofPinterest()"
                                          >créer</vs-button>
                                        </div>
                                    </div>
                                  </div>


                            <div class="table-subtitle">
                                <p>{{ $t('dash.bots.post_frequency') }}</p>
                            </div>
                            <p class="subtitle">
                                {{ $t('dash.bots.post_frequency_subtitle') }}
                            </p>

                            <div class="frequency">
                                <div class="defined">   

                                    <div class="instant frequency-item" v-if="activeInstant">
                                      <div class="frequency-item">
                                          <input
                                                  type="radio"
                                                  name="frequency"
                                                  v-model="bot.frequency"
                                                  :value="{ custom: false, value: 'instant' }"
                                                  :disabled="bot.sourceType == 'none' || bot.posts.display_instagram === 'story'"
                                                  :class="{'disabled': bot.sourceType == 'none' || bot.posts.display_instagram === 'story'}"                                                
                                                  data-qa="form-bot-frequency-instant"
                                          />
                                          <div class="frequency-wrapper">
                                              <p>{{ $t('dash.bots.post_instant') }}</p>
                                              <img class="white" src="../../../assets/img/tabs/Bots-icon-white.svg" alt="bot">
                                              <img class="pink" src="../../../assets/img/tabs/Bots-icon.svg" alt="bot">
                                          </div>
                                      </div>
                                    </div>

                                    <div
                                            class="frequency-item"
                                            v-for="f in possibleFrequencies"
                                            :key="f"
                                    >
                                        <input
                                                type="radio"
                                                name="frequency"
                                                v-model="bot.frequency"
                                                :value="{ value: f, custom: false }"
                                                :disabled="bot.sourceType == 'none'  || bot.posts.display_instagram === 'story'"
                                                :class="{'disabled': bot.sourceType == 'none'  || bot.posts.display_instagram === 'story'}"
                                                :data-qa="`form-bot-frequency-${f}`"
                                        />
                                        <div class="frequency-wrapper">
                                            <p v-html="humanizeTime(f)"></p>
                                        </div>
                                    </div>
                                    <div class="frequency-item custom-frequency" 
                                      v-if="bot.sourceType != 'none'">
                                        <input
                                                type="radio"
                                                name="frequency"
                                                id="custom-frequency-radio"
                                                v-model="bot.frequency.custom"
                                                :value="true"
                                                @click="frequencyInputElt.select()"
                                        />
                                        <div class="frequency-wrapper">
                                            <vs-input-number
                                                    id="custom-frequency-nbr"
                                                    color="dark"
                                                    size="mini"
                                                    :step="5"
                                                    @keypress.enter.prevent
                                                    :placeholder="$t('dash.bots.post_frequency_other')"
                                                    v-model="bot.frequency.value"
                                                    @focus="bot.frequency.custom = true"
                                                    @change="
                                                      bot.frequency.value =
                                                        bot.frequency.value % minimumFrequency == 0
                                                          ? bot.frequency.value
                                                          : parseInt(bot.frequency.value) + parseInt(minimumFrequency) - (bot.frequency.value % minimumFrequency)
                                                        /*bot.frequency.value < minimumFrequency
                                                          ? minimumFrequency
                                                          : bot.frequency.value*/
                                                    "
                                                    @blur="
                                                      bot.frequency.value =
                                                        bot.frequency.value % minimumFrequency == 0
                                                          ? bot.frequency.value
                                                          : bot.frequency.value + minimumFrequency - (bot.frequency.value % minimumFrequency)
                                                        /*bot.frequency.value < minimumFrequency
                                                          ? minimumFrequency
                                                          : bot.frequency.value*/
                                                    "
                                            />
                                            <p>&nbsp;(min)</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="manual">
                                    <div class="frequency-item">
                                        <input
                                                type="radio"
                                                name="frequency"
                                                v-model="bot.frequency"
                                                :value="{ custom: false, value: 0 }"
                                                data-qa="form-bot-frequency-manual"
                                        />
                                        <div class="frequency-wrapper">
                                            <p>{{ $t('dash.bots.post_frequency_manual') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="limit" v-if="!checkLock('partner')">
                                <div class="table-subtitle">
                                    <p>{{ $t('dash.bots.post_limit') }}</p>
                                </div>
                                <p class="subtitle">{{ $t('dash.bots.post_limit_subtitle') }}</p>

                                <div class="limit-wrapper">
                                    <vs-radio
                                            :class="{ active: showLimit == 'false' }"
                                            v-model="showLimit"
                                            vs-value="false"
                                            :disabled="!checkLock('bots_daily') && !checkLock('partner')"
                                            :style="{filter: !checkLock('bots_daily') && !checkLock('partner') ? 'grayscale(1)' : ''}"
                                    >
                                        {{ $t('dash.bots.post_limit_nolimit') }}
                                    </vs-radio>
                                    <vs-radio
                                            :class="{ active: showLimit == 'true' }"
                                            v-model="showLimit"
                                            vs-value="true"
                                    >
                                        {{ $t('dash.bots.post_limit_yeslimit') }}
                                    </vs-radio>
                                    <Tooltip :text="checkLock('posts_limit') !== Infinity ? checkLock('posts_limit')+' '+this.$t('dash.settings.plans.details.post_limit_per_day')+' max' : ''" position="right">
                                      <vs-input-number
                                       @keypress.enter.prevent
                                              v-if="showLimit == 'true'"
                                              color="dark"
                                              size="mini"
                                              placeholder="0"
                                              v-model="bot.limit"
                                              :max="checkLock('posts_limit')"
                                              :min="1"
                                      />
                                    </Tooltip>
                                </div>
                            </div>

                            <!-- Planning - uncomment if needed -->
                            <div class="table-subtitle">
                              <p>Planning</p>
                            </div>
                            <div class="planning">
                              <component-planning
                                v-on:change="updatePlanning"
                                :week="bot.planning">
                              </component-planning>
                            </div>

                            <div class="table-subtitle" v-if="['facebook', 'twitter', 'linkedin'].includes(selectedPage.network)">
                              <p>{{ $t('dash.bots.after-auto-post_subtitle') }} <span>(Beta)</span></p>
                            </div>
                            <div class="after-auto-post" v-if="['facebook', 'twitter', 'linkedin'].includes(selectedPage.network)">
                              <!-- retweet auto -->
                              <div class="retweet-auto" v-if="selectedPage.network == 'twitter'">
                                <p class="subtitle">
                                  {{ $t('dash.bots.retweetAuto_subtitle') }}
                                  <span v-if="bot.afterAutoPost && bot.afterAutoPost.retweetAuto && bot.afterAutoPost.retweetAuto.length > 0 && bot.afterAutoPost.retweetAuto.filter(r => r.active).length > 0">({{ bot.afterAutoPost.retweetAuto.filter(r => r.active).length }} retweet)</span>
                                </p>
                                <div class="content">
                                  <ul>
                                    <li class="row" v-for="(retweetAuto, key) in bot.afterAutoPost.retweetAuto" :key="`used-${key}`"> 
                                      <div v-if="getPage(retweetAuto.page)">  
                                        <div class="page">
                                          <div class="page-wrapper" >
                                            <div class="page-content">
                                              <vs-switch v-model="bot.afterAutoPost.retweetAuto[key].active"/>
                                              <div class="vertical-align">
                                                <page-image-avatar :page="getPage(retweetAuto.page)"/>
                                                <p class="page-name">{{ getPage(retweetAuto.page).name }}</p>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="frequency" v-if="retweetAuto.active">
                                          <div class="defined">   
                                            <div
                                              class="frequency-item"
                                              v-for="f in possibleFrequencies"
                                              :key="f"
                                            >
                                              <input
                                                type="radio"
                                                :name="`retweet-frequency-${key}`"
                                                v-model="bot.afterAutoPost.retweetAuto[key].frequency"
                                                :value="{ value: f, custom: false }"
                                                :disabled="bot.sourceType == 'none'  || bot.posts.mode === 'story'"
                                                :class="{'disabled': bot.sourceType == 'none'  || bot.posts.mode === 'story'}"
                                              />
                                              <div class="frequency-wrapper">
                                                <p v-html="humanizeTime(f)"></p>
                                              </div>
                                            </div>
                                            <div class="frequency-item custom-frequency" v-if="bot.sourceType != 'none' && bot.posts.mode !== 'story'">
                                              <input
                                                type="radio"
                                                name="frequency"
                                                id="custom-frequency-radio"
                                                v-model="bot.afterAutoPost.retweetAuto[key].frequency.custom"
                                                :value="true"
                                                @click="document.querySelector(`#custom-retweet-frequency-nbr-${key}`).select()"
                                              />
                                              <div class="frequency-wrapper">
                                                <vs-input-number
                                                  :id="`custom-retweet-frequency-nbr-${key}`"
                                                  color="dark"
                                                  size="mini"
                                                  :step="5"
                                                   @keypress.enter.prevent
                                                  :placeholder="$t('dash.bots.post_frequency_other')"
                                                  v-model="bot.afterAutoPost.retweetAuto[key].frequency.value"
                                                  @focus="bot.afterAutoPost.retweetAuto[key].frequency.custom = true"
                                                  @change="
                                                    bot.afterAutoPost.retweetAuto[key].frequency.value =
                                                      bot.afterAutoPost.retweetAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.retweetAuto[key].frequency.value
                                                        : parseInt(bot.afterAutoPost.retweetAuto[key].frequency.value) + parseInt(minimumFrequency) - (bot.afterAutoPost.retweetAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                  @blur="
                                                    bot.afterAutoPost.retweetAuto[key].frequency.value =
                                                      bot.afterAutoPost.retweetAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.retweetAuto[key].frequency.value
                                                        : bot.afterAutoPost.retweetAuto[key].frequency.value + minimumFrequency - (bot.afterAutoPost.retweetAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                />
                                                <p>&nbsp;(min)</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    </li>
                                    <li class="row" v-for="(item, key) in getSameNetworkPagesWithBot.filter(p => !bot.afterAutoPost.retweetAuto.find(r => r.page == p.id))" :key="`unused-${key}`">   
                                      <div class="page">
                                        <div class="page-wrapper" >
                                          <div class="page-content">
                                            <vs-switch v-on:click.prevent="addAfterAutoPost('retweet', item)"/>
                                            <div class="vertical-align">
                                              <page-image-avatar :page="item"/>
                                              <p class="page-name">{{ item.name }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <!-- reshare auto -->
                              <div class="reshare-auto" v-if="selectedPage.network == 'facebook'">
                                <p class="subtitle">
                                  {{ $t('dash.bots.reshareAuto_subtitle') }}
                                  <span v-if="bot.afterAutoPost && bot.afterAutoPost.reshareAuto && bot.afterAutoPost.reshareAuto.length > 0 && bot.afterAutoPost.reshareAuto.filter(r => r.active).length > 0">({{ bot.afterAutoPost.reshareAuto.filter(r => r.active).length }} reshare)</span>
                                </p>
                                <div class="content">
                                  <ul>
                                    <li class="row" v-for="(reshareAuto, key) in bot.afterAutoPost.reshareAuto" :key="`used-${key}`">
                                      <div v-if="getPage(reshareAuto.page)">   
                                        <div class="page">
                                          <div class="page-wrapper" >
                                            <div class="page-content">
                                              <vs-switch v-model="bot.afterAutoPost.reshareAuto[key].active"/>
                                              <div class="vertical-align">
                                                <page-image-avatar :page="getPage(reshareAuto.page)"/>
                                                <p class="page-name">{{ getPage(reshareAuto.page).name }}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="frequency" v-if="reshareAuto.active">
                                          <div class="defined">   
                                            <div
                                              class="frequency-item"
                                              v-for="f in possibleFrequencies"
                                              :key="f"
                                            >
                                              <input
                                                type="radio"
                                                :name="`reshare-frequency-${key}`"
                                                v-model="bot.afterAutoPost.reshareAuto[key].frequency"
                                                :value="{ value: f, custom: false }"
                                                :disabled="bot.sourceType == 'none'  || bot.posts.mode === 'story'"
                                                :class="{'disabled': bot.sourceType == 'none'  || bot.posts.mode === 'story'}"
                                              />
                                              <div class="frequency-wrapper">
                                                <p v-html="humanizeTime(f)"></p>
                                              </div>
                                            </div>
                                            <div class="frequency-item custom-frequency" v-if="bot.sourceType != 'none' && bot.posts.mode !== 'story'">
                                              <input
                                                type="radio"
                                                name="frequency"
                                                id="custom-frequency-radio"
                                                v-model="bot.afterAutoPost.reshareAuto[key].frequency.custom"
                                                :value="true"
                                                @click="document.querySelector(`#custom-reshare-frequency-nbr-${key}`).select()"
                                              />
                                              <div class="frequency-wrapper">
                                                <vs-input-number
                                                  :id="`custom-reshare-frequency-nbr-${key}`"
                                                  color="dark"
                                                  size="mini"
                                                  :step="5"
                                                   @keypress.enter.prevent
                                                  :placeholder="$t('dash.bots.post_frequency_other')"
                                                  v-model="bot.afterAutoPost.reshareAuto[key].frequency.value"
                                                  @focus="bot.afterAutoPost.reshareAuto[key].frequency.custom = true"
                                                  @change="
                                                    bot.afterAutoPost.reshareAuto[key].frequency.value =
                                                      bot.afterAutoPost.reshareAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.reshareAuto[key].frequency.value
                                                        : parseInt(bot.afterAutoPost.reshareAuto[key].frequency.value) + parseInt(minimumFrequency) - (bot.afterAutoPost.reshareAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                  @blur="
                                                    bot.afterAutoPost.reshareAuto[key].frequency.value =
                                                      bot.afterAutoPost.reshareAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.reshareAuto[key].frequency.value
                                                        : bot.afterAutoPost.reshareAuto[key].frequency.value + minimumFrequency - (bot.afterAutoPost.reshareAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                />
                                                <p>&nbsp;(min)</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                    <li class="row" v-for="(item, key) in getSameNetworkPagesWithBot.filter(p => !bot.afterAutoPost.reshareAuto.find(r => r.page == p.id))" :key="`unused-${key}`">   
                                      <div class="page">
                                        <div class="page-wrapper" >
                                          <div class="page-content">
                                            <vs-switch v-on:click.prevent="addAfterAutoPost('reshare', item)"/>
                                            <div class="vertical-align">
                                              <page-image-avatar :page="item"/>
                                              <p class="page-name">{{ item.name }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <!-- repost auto -->
                              <div class="repost-auto">
                                <p class="subtitle">
                                  {{ $t('dash.bots.repostAuto_subtitle') }}
                                  <span v-if="bot.afterAutoPost && bot.afterAutoPost.repostAuto && bot.afterAutoPost.repostAuto.length > 0 && bot.afterAutoPost.repostAuto.filter(r => r.active).length > 0">({{ bot.afterAutoPost.repostAuto.filter(r => r.active).length }} repost)</span>
                                </p>
                                <div class="content">
                                  <ul>
                                    <li class="row" v-for="(repostAuto, key) in bot.afterAutoPost.repostAuto" :key="`used-${key}`"> 
                                      <div v-if="getPage(repostAuto.page)">
                                        <div class="page">
                                          <div class="page-wrapper" >
                                            <div class="page-content">
                                              <vs-switch v-model="bot.afterAutoPost.repostAuto[key].active"/>
                                              <div class="vertical-align">
                                                <page-image-avatar :page="getPage(repostAuto.page)"/>
                                                <p class="page-name">{{ getPage(repostAuto.page).name }}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="frequency" v-if="repostAuto.active">
                                          <div class="defined">   
                                            <div
                                              class="frequency-item"
                                              v-for="f in possibleFrequencies"
                                              :key="f"
                                            >
                                              <input
                                                type="radio"
                                                :name="`repost-frequency-${key}`"
                                                v-model="bot.afterAutoPost.repostAuto[key].frequency"
                                                :value="{ value: f, custom: false }"
                                                :disabled="bot.sourceType == 'none'  || bot.posts.mode === 'story'"
                                                :class="{'disabled': bot.sourceType == 'none'  || bot.posts.mode === 'story'}"
                                              />
                                              <div class="frequency-wrapper">
                                                <p v-html="humanizeTime(f)"></p>
                                              </div>
                                            </div>
                                            <div class="frequency-item custom-frequency" v-if="bot.sourceType != 'none' && bot.posts.mode !== 'story'">
                                              <input
                                                type="radio"
                                                name="frequency"
                                                id="custom-frequency-radio"
                                                v-model="bot.afterAutoPost.repostAuto[key].frequency.custom"
                                                :value="true"
                                                @click="document.querySelector(`#custom-repost-frequency-nbr-${key}`).select()"
                                              />
                                              <div class="frequency-wrapper">
                                                <vs-input-number
                                                  :id="`custom-repost-frequency-nbr-${key}`"
                                                  color="dark"
                                                  size="mini"
                                                  :step="5"
                                                   @keypress.enter.prevent
                                                  :placeholder="$t('dash.bots.post_frequency_other')"
                                                  v-model="bot.afterAutoPost.repostAuto[key].frequency.value"
                                                  @focus="bot.afterAutoPost.repostAuto[key].frequency.custom = true"
                                                  @change="
                                                    bot.afterAutoPost.repostAuto[key].frequency.value =
                                                      bot.afterAutoPost.repostAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.repostAuto[key].frequency.value
                                                        : parseInt(bot.afterAutoPost.repostAuto[key].frequency.value) + parseInt(minimumFrequency) - (bot.afterAutoPost.repostAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                  @blur="
                                                    bot.afterAutoPost.repostAuto[key].frequency.value =
                                                      bot.afterAutoPost.repostAuto[key].frequency.value % minimumFrequency == 0
                                                        ? bot.afterAutoPost.repostAuto[key].frequency.value
                                                        : bot.afterAutoPost.repostAuto[key].frequency.value + minimumFrequency - (bot.afterAutoPost.repostAuto[key].frequency.value % minimumFrequency)
                                                  "
                                                />
                                                <p>&nbsp;(min)</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>  
                                    </li>
                                    <li class="row" v-for="(item, key) in getAllPagesWithBot.filter(p => !bot.afterAutoPost.repostAuto.find(r => r.page == p.id))" :key="`unused-${key}`">   
                                      <div class="page">
                                        <div class="page-wrapper" >
                                          <div class="page-content">
                                            <vs-switch v-on:click.prevent="addAfterAutoPost('repost', item)"/>
                                            <div class="vertical-align">
                                              <page-image-avatar :page="item"/>
                                              <p class="page-name">{{ item.name }}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <i
                                    v-show="errors.has('bot.title')"
                                    class="warning-lbl fa fa-warning"
                            ></i>
                            <span v-show="errors.has('bot.title')" class="help is-danger">{{errors.first('bot.title')}}</span>
                            <div class="buttons-wrapper">
                                <!-- Catch focus in case <Enter> is pressed -->
                                <button
                                  style="display:none;"
                                  @click.prevent.stop="() => void 0"
                                />
                                <!-- Provide true edition buttons -->
                                <vs-button
                                  color="#303030"
                                  class="btn-large"
                                  @click.prevent.stop="cleanData"
                                  vs-type="filled"
                                >{{ $t('dash.button.cancel') }}</vs-button>
                                <vs-button
                                  color="#303030"
                                  class="btn-large"
                                  @click.prevent.stop="removeBot"
                                  v-if="editedBotExists"
                                  vs-type="filled"
                                  data-qa="form-bot-remove"
                                >{{ $t('dash.button.delete') }}
                                </vs-button>
                                <template v-if="botIsValid">
                                  <vs-button
                                    v-if="!editedBotExists"
                                    color="#303030"
                                    class="btn-large btn-img"
                                    vs-type="filled"
                                    button="submit"
                                    data-qa="form-bot-submit"
                                    @click.prevent="submit('bot')"
                                  >
                                    <p>{{ $t('dash.button.launch') }}</p>
                                    <img src="../../../assets/img/icon_launch.svg"
                                         alt="search" />
                                  </vs-button>
                                  <vs-button
                                    v-else
                                    color="#303030"
                                    class="btn-large"
                                    @click.prevent.stop="update"
                                    vs-type="filled"
                                    data-qa="form-bot-submit"
                                  >{{ $t('dash.button.save') }}
                                  </vs-button>
                                </template>
                                <template v-else>
                                    <Tooltip :text="$t('dash.bots.invalidBot')" position="right">
                                      <vs-button
                                        v-if="!editedBotExists"
                                        color="#303030"
                                        class="btn-large btn-img"
                                        vs-type="filled"
                                        disabled="true"
                                        button="submit"
                                      >
                                        <p>{{ $t('dash.button.launch') }}</p>
                                        <img src="../../../assets/img/icon_launch.svg"
                                           alt="search" />
                                      </vs-button>
                                      <vs-button
                                        v-else
                                        color="#303030"
                                        class="btn-large"
                                        vs-type="filled"
                                        disabled="true"
                                        button="submit"
                                      >{{ $t('dash.button.save') }}
                                      </vs-button
                                      >
                                    </Tooltip>
                                </template>
                            </div>
                        </template>
                    </div>
                </form>
            </vs-col>
        </vs-row>
        <vs-popup :title="dialog.title" :active.sync="dialog.show">
            <p>{{ dialog.message }}</p>
        </vs-popup>
    </div>
</template>

<script>
  import VueTagsInput from '@johmun/vue-tags-input'
  import Autocomplete from 'vuejs-auto-complete'
  import Bots from '../../mixins/Bots'
  import Pages from '../../mixins/Pages'
  import Sources from '../../mixins/Sources'
  import Upgradable from '../../mixins/Upgradable'
  import User from '../../mixins/User'
  import Posts from '../../mixins/Posts'
  import Groups from '../../mixins/Groups'
  import Common from '../../mixins/Common'
  import Notif from '../../mixins/Notif'
  import componentMultipletable from './../Multipletable.vue'
  import componentPlanning from './../Planning.vue'
  import componentTable from './../Table.vue'
  import componentSourcesOverlay from './../overlay/Sources.vue'
  import Lock from '../../../utils/Lock'
  import emojiData from 'emoji-mart-vue-fast/data/all.json'
  import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
  import 'emoji-mart-vue-fast/css/emoji-mart.css'
  import ClickOutside from 'vue-click-outside'
  import componentStoryMaker from '../StoryMaker.vue'
  import componentTemplateMaker from '../TemplateMaker.vue'
  import PageImageAvatar from '../PageImageAvatar.vue'
  import TwoFactorAuthenticationPopup from '../TwoFactorAuthenticationPopup.vue'
  import componentLoader from './../overlay/Loader.vue'
  import componentConciergerie from './../overlay/Conciergerie.vue'

  import Queuer from '../../../utils/Queuer'
  import Tooltip from './../tooltip/tooltipInit.vue'

  let slug = require('slug')

  const { VUE_APP_DASHBOARD_API } = process.env

  export default {
    name: 'component-bots',

    components: {
      componentMultipletable,
      componentTable,
      componentPlanning,
      Autocomplete,
      VueTagsInput,
      componentSourcesOverlay,
      Picker,
      componentStoryMaker,
      componentTemplateMaker,
      PageImageAvatar,
      TwoFactorAuthenticationPopup,
      componentLoader,
      componentConciergerie,
      Tooltip
    },

    mixins: [Bots, Pages, Sources, Upgradable, User, Common, Posts, Groups, Notif],

    data() {
      return {
        usernamePageDiff: null,
        instagramPagesUsernames: [],
        connectionReturn: false,
        extension: false,
        showPass: false,
        scrollId: null,
        linkedinModify: false,
        linkedinUsername: '',
        linkedinPassword: '',
        twoFactorPopup: false,
        newHighlight: '',
        highlightsPage: [],
        modeInsta: 'standard',
        templateMode: 'manual',
        templateStory: {
          shared: false,
          configuration: null,
          highlight: null,
          predefined: null,
        },
        // Views switch
        section: 'main',
        scroll: false,
        boards: null,
        boardSelected:null,
        selectPinterest:false,
        newBoardName: null,
        dialog: {
          show: false,
          title: 'Bots',
          message: null
        },

        // Bot object
        // Is populated by either the bot to edit or an empty bot
        bot: null,
        bots: [],

        pages: [],
        // Initial infos
        themes: [],
        languages: [],

        // Hastags
        autocompleteTags: [],
        // uncomment if needed for blacklists suggestions
        // autocompleteTags: [{
        //   text: 'Spain',
        // }, {
        //   text: 'France',
        // }, {
        //   text: 'USA',
        // }, {
        //   text: 'Germany',
        // }, {
        //   text: 'China',
        // }],

        allSourcesBtnSelect: true,

        // Source filters
        sources: {
          search: '',
          filter: '',
          filters: [
            { text: 'No filter', value: 0 },
            { text: 'My sources', value: 1 },
            { text: 'Mashup', value: 2 }
          ],
          order: 'date',
          orders: {
            date: 1,
            title: 1,
            author: 1
          },
          sourceList: [],
          filteredSourceList: []
        },

        showLimit: 'false',

        // Bots table
        gridColumns: [
          'pages',
          ['name', 'topic', 'subtopic', 'source', 'frequency', 'status']
        ],

        // APIs limitations
        limitations: {
          frequency: {
            twitter: 2,
            facebook: 2 //5
          }
        },

        addSource: false,
        newSources: [],

        showEmojiPicker: false,
        showEmojiPickerSuffix: false,
        showEmojiPickerPrefix: false,
        emojiIndex: new EmojiIndex(emojiData),

        autoMentions: [],
        openAutoMentions: false,

        manualName: false,

        //Instagram Stories
        createTemplatePopup: false,
        changeCredential: false,

        selectedPages: [],
        selectedGroups: [],
        gridData: [],
        pageFilter: '',
        groups: [],
        showLoader: false,
        // advancedTabs: true,

        // showEnabledBots: true
      }
    },

    directives: {
      ClickOutside
    },

    props: {
      addBot: Boolean,
      tabsIsMinimize: Boolean
    },

    computed: {

      enabledBotsExists() {
        return this.bots.filter(bot => this.linkedPages.find(p => bot.page.id === p.id) && (bot.frequency || ((bot.flux && bot.flux.length) || bot.category))).length > 0
      },

      linkedinConnected() {
        if (this.linkedinModify) {
          return 'modify';
        }
        if (this.selectedPage.story_config && ((this.selectedPage.network === 'linkedin' && this.selectedPage.story_config.cookies) || (this.selectedPage.network === 'instagram' && this.selectedPage.story_config.session_state))) {
          return 'connected';
        } else if (this.selectedPage.story_config && ((this.selectedPage.network === 'linkedin' && this.selectedPage.story_config.challenge_informations) || (this.selectedPage.network === 'instagram' && this.selectedPage.story_config.two_factor))) {
          return 'challenge';
        } else {
          return 'none';
        }
      },

      isValidHightlight() {
        if (this.highlightsPage) {
          let h = this.highlightsPage.map(e => e.title);
          return this.templateStory && (this.templateStory.highlight === '__new_highlight__' && this.newHighlight !== '' && !h.includes(this.newHighlight)) || this.templateStory.highlight !== '__new_highlight__';
        }
      },
      
      activeLog(){
        const logUser = [
          //sandbox
          'aiminne+free1@mashup-web.com',
          //prod
          "aiminne@mashup-web.com",
          "matthieu@mashup-web.com",
          "vdiakov@reworldmedia.com",
          "ldesmarecaux@reworldmedia.com",
          'ajeunet@reworldmedia.com',
          'mashup.md@reworldmedia.com',
          "a.samari@sfmd.fr",
          "egrasset@reworldmedia.com",
          'pascale@dreamago.com'
        ]
        const logAccount = [
          //prod
          "c93f4d0a-d1eb-4561-8071-bd4ef9fdf72a", //rcf
        "ed24f2ca-61dc-477a-9508-237845ff9423", //studiomandarine
        "da502f9e-c999-4896-baed-4e1c4110409a", //wmki
        "d2e5ed17-eaf3-4ba0-a2ba-9e1f95757776", //fcr
        ]
        const user = JSON.parse(localStorage.user)
        return logUser.includes(user.email) || logAccount.includes(user.account) 
      },

      activeInstagramStories() {
        const accounts = [
          '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
          'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
          'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
          '251e3e67-2bc7-4634-b6e7-4be8ea1105aa', //auto-ies
          '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
          'd3035c77-8361-4e28-8239-66b672bfa72c', //honorsguests
          '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
          '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
          '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
          '90e789fa-7377-434c-b719-132aa8bcd1d2', //keepeo.fr
          'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
          '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
          '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
          '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
        ]

        const users = [
          '7a4c371e-86b7-4c7f-b217-83203e9e8e17' //Augagneur reworld
        ]

        const user = JSON.parse(localStorage.user)
        //return accounts.includes(user.account) || this.checkLock('instagram_story') || user.email.includes("@mashup-web.com")
        return this.checkLock('instagram_credentials') || accounts.includes(user.account) || users.includes(user.id) || user.email.includes("@mashup-web.com")
      },

      activeLinkedinCredentials() {
        const accounts = [
          '935a2b07-141c-432f-a54e-975125fdeefc', //david NWX
          '251e3e67-2bc7-4634-b6e7-4be8ea1105aa', //Auto-ies
          '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
          /*'63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
          'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
          'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard*/
          'eb8ae373-cb54-46d2-b456-1b60b568b62f', // groupebba-bma.com
          '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
          '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
          '90e789fa-7377-434c-b719-132aa8bcd1d2', //keepeo.fr
          'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
          '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
          '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
          '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
        ]

        const users = [
          '7a4c371e-86b7-4c7f-b217-83203e9e8e17' //Augagneur reworld
        ]

        const user = JSON.parse(localStorage.user)
        return this.checkLock('linkedin_credentials') || accounts.includes(user.account) || users.includes(user.id) || user.email.includes("@mashup-web.com")
      },

      getTwitterPagesWithBot(){
        return this.pages.filter(page => page.network == 'twitter' && this.bots.find(bot => bot.page.id == page.id))
      },

      getSameNetworkPagesWithBot(){
        let currentBotOnCreate = this.bot.id == null ? this.pages.find(page => this.bot.page == page.id) : []
        let page = this.pages.find(p => p.id == this.bot.page)
        return this.pages.filter(p => p.network == page.network && this.bots.find(b => b.page.id == p.id)).concat(currentBotOnCreate)
      },

      getBoardPagePinterest(){
        let page = this.pages.find(p => p.id == this.bot.page)
        
        if(page.network == 'pinterest'){
          this.getBoardofPinterest(page)
          return true
        }
        else
          return false
      },
      
      getAllPagesWithBot(){
        let currentBotOnCreate = this.bot.id == null ? this.pages.find(page => this.bot.page == page.id) : []
        return this.pages.filter(page => this.bots.find(bot => bot.page.id == page.id)).concat(currentBotOnCreate)
      },

      getMentions(){
        let mentionsArray = []
        this.bot.mentions.forEach(m => {
          //console.log(m)
          if(m.mention != "" && m.correspondences.length > 0) {
            let mentionObject = {
              'mention': m.mention,
              'correspondences': m.correspondences.map(x => x.text || x)
            }
            mentionsArray.push(mentionObject)
          }
        })
        return mentionsArray
      },

      getHashtagsAuto(){
        let hashtagsAutoArray = []
        this.bot.hashtagsAuto.forEach(m => {
          //console.log(m)
          if(m.hashtag != "" && m.correspondences.length > 0) {
            let hashtagObject = {
              'hashtag': m.hashtag,
              'correspondences': m.correspondences.map(x => x.text || x)
            }
            hashtagsAutoArray.push(hashtagObject)
          }
        })
        return hashtagsAutoArray
      },

      getSourcesList() {
        return this.bot.sourceType === 'normal' ? this.sources.filteredSourceList : this.newSources
      },

      /**
       * New bot subsection if URL is `/dash/bots/new`
       */
      activeSection() {
        /*return ['new', 'edit'].some(x => this.$route.path.endsWith(x))
          ? 'new'
          : 'main'*/
        
        /*return ['new', 'edit'].some(x => this.$route.path.endsWith(x))
          ? (this.$route.path.endsWith('new') ? 'new' : 'edit')
          : 'main'*/

        return this.addBot 
          ? 'new'
          : (['new', 'edit'].some(x => this.$route.path.endsWith(x))
            ? (this.$route.path.endsWith('new') ? 'new' : 'edit')
            : 'main')
      },
      isEditSection() {
        return this.$route.path.endsWith('edit')
      },
      editedBotExists() {
        return this.bot && this.bot.id
      },
      linkedPages() {
        return this.pages
        //return this.pages.sort((a,b) => (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0))  ///////
      },
      authHeaders: () => ({ Authorization: `Bearer ${localStorage.token}` }),
      filteredItems() {
        return this.autocompleteTags.filter(i =>
          new RegExp(this.bot.blacklists.tag, 'i').test(i.text)
        )
      },
      selectedPage() {
        return this.linkedPages.find(x => x.id === this.bot.page)
      },
      /**
       *
       * @return {Array}
       */
      possibleFrequencies() {
        if (!this.selectedPage)
          return []

        const { network } = this.selectedPage
        const limit = this.limitations.frequency[network]
        return [/*0, */2, 5, 10, 30, 60, 120, 240, 360].filter(
          freq => limit === undefined || freq >= limit
        )
      },
      minimumFrequency() {
        return this.selectedPage.network === 'twitter'
          ? 2
          : this.possibleFrequencies[0]
      },
      frequencyInputElt: () => document.querySelector('#custom-frequency-nbr'),
      /*gridData() {

        let grid = Object.values(this.linkedPages).map(v => ({
          pages: v,
          bots: this.bots.filter(bot => bot.page.id === v.id)
        }))
        //sort by bots active and pages name
        grid = grid.slice().sort((a,b) => {
          if((a.bots.length == 0 && b.bots.length == 0) || (a.bots.length > 0 && b.bots.length > 0)){
            return (a.pages.name > b.pages.name) ? 1 : ((a.pages.name < b.pages.name) ? -1 : 0)
          }
          else if(a.bots.length > 0){
            return -1
          }
          else if(b.bots.length > 0){
            return 1
          }
        })
        //sort by bots name
        grid = Object.values(grid).map(g => ({
          pages: g.pages,
          bots: g.bots.sort((a,b) => (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0))
        }))
        //sort bots by updated_at 
        grid = Object.values(grid).map(g => ({
          pages: g.pages,
          bots: g.bots.sort((a,b) => (a.updated_at < b.updated_at) ? 1 : ((a.updated_at > b.updated_at) ? -1 : 0))
        }))
        //sort pages by bots updated_at 
        grid = grid.slice().sort((a,b) => {
          if(a.bots.length == 0 && b.bots.length == 0) return 0 
          else if(a.bots.length > 0 && b.bots.length == 0) return -1
          else if(a.bots.length == 0 && b.bots.length > 0) return 1
          else if(a.bots[0].updated_at < b.bots[0].updated_at) return 1
          else if(a.bots[0].updated_at > b.bots[0].updated_at) return -1
          else return 0
        })
        return grid
      },*/
      botsCount() {
        return this.gridData.reduce((acc, x) => acc + x.bots.length, 0)
      },
      botIsValid() {
        const { sources, whitelist, topics, name, page, sourceType } = this.bot
        console.log('ici :', this.bot.posts.mode, (this.selectedPage.instagram_username ? true : false), (this.selectedPage.instagram_password ? true : false), (this.selectedPage.network === 'instagram' && this.bot.posts.mode !== 'story'), this.templateStory, this.isValidHightlight, this.bot.instagram.credentials.username, this.bot.instagram.credentials.password, this.modeInsta, this.selectedPage);
        return (
          ((whitelist && whitelist.length) 
            || (topics && topics.category && topics.category.id && this.allSourcesBtnSelect) 
            || sources.length || sourceType == 'none') &&
          name &&
          page &&
          ((this.selectedPage.network === 'instagram' && this.modeInsta !== 'story') || this.selectedPage.network !== 'instagram'
          || ((this.selectedPage.network === 'instagram' && this.modeInsta === 'story') && (this.bot.instagram.credentials && (this.bot.instagram.credentials.username ? true : false) && (this.bot.instagram.credentials.password ? true : false)) || (this.selectedPage.instagram_username ? true : false)) 
          ) && ((this.selectedPage.network === 'instagram' && this.bot.posts.mode === 'story' && this.templateStory && this.isValidHightlight) || (this.bot.posts.mode !== 'story')) 
        )
      },
      selectedSources() {
        return this.bot.sources
                   .filter(s => s && (s.uid || s.id))
                   .map(s => s.uid || s.id)
      },

      activeInstant(){

        const user = JSON.parse(localStorage.user)
        return this.checkLock('instant') || user.email.includes("@mashup-web.com")

        //return true

        /*const accounts = [
          '2a404c33-e7c2-41ac-b268-8b4cfae5ad5b', //Toutsurlehockey
          '7a5cd08d-2ebc-4d46-aaf5-760188603260', //Cyclismactu
          'e480002b-1c62-41e6-968f-c09d365b0741', //Reworld
          '0960a21c-6e71-44c0-aa5e-ba213a647981', //foot01 - capton
          '32981359-b2bd-4d42-bd43-8fc0faaeee38', //Horyzon
        ]
        const user = JSON.parse(localStorage.user)
        return accounts.includes(user.account) || user.email.includes("@mashup-web.com")*/
      }
    },

    mounted() {
      localStorage.setItem('section', 'bots')
      this.$emit('on-close-bot-form')
      this.$ga.page(this.$router)
      // Use default bot
      this.bot = { ...this.defaultBot }
      if (this.$route.query.twofactor) {
        this.twoFactorPopup = this.$route.query.twofactor;
      }
      this.extensionInstalled();
      this.getInstagramPagesUsername();
      this.showLoader = true
      // Get themes
      this.fetchThemes()
          .then(this.fetchLanguages) // Get Languages
          .then(this.fetchPages) // Get bots
          .then(this.fetchSources) // Get sources
          .then(this.fetchBots)
          // .then(() => {
          //   this.showEnabledBots = this.enabledBotsExists
          // })
          .then(this.orderedPages)
          .then(this.fetchGroups())
          .then(() => {
            if (this.$route.params.source) {
              let result = this.sources.sourceList.find(element => {
                return element.id === this.$route.params.source
              })
              this.bot.sources.push(result)
            } else if (this.$route.params.bot) {
              this.scrollId = this.$route.params.scroll
              this.editBot(this.$route.params.bot)
            }
          })
          .then(() => this.showLoader = false)
          .catch(this.handleError)
    },

    beforeDestoyed : () => {
      this.$emit('on-close-bot-form')
    },

    methods: {
    
    async getInstagramPagesUsername() {
      this.getPages().then(res => {
        let {pages} = res.body;
        this.instagramPagesUsernames = pages.filter(e => e.network === 'instagram').map(e => {return {username: e.instagram_username, name: e.name}});
      })
    },

    async extensionInstalled() {
      return new Promise((resolve, reject) => {
        let img = new Image();
        const extensionId = "ejhibpanghbhejmioehmpkflhaoojglm"
        img.src = "chrome-extension://" + extensionId + "/icons/icon_16.png";
        img.onload = () => {
          this.extension = true;
          resolve(true);
        };
        img.onerror = () => {
          this.extension = false;
          resolve(false);
        };
      });
    },

    useExtension() {
      if (typeof chrome !== 'undefined') {
        this.extensionInstalled().then(installed => {
          if (installed) {
            window.open("https://linkedin.com/", '_blank').focus();
          } else {
            console.log('redirect to download link');
            window.open("https://chrome.google.com/webstore/detail/mashup-web/lmojmckfefcipoompcaedhnbbkeceohm", '_blank').focus();
          }
        })
      } else {
        this.$vs.notify({
          title: "Navigateur incompatible",
          text: this.$t("dash.bots.extension_chrome_only"),
          color:'warning',
          time: 10000
        })
      }
    },

      async disconnectConciergerie(idPage) {
        console.log(idPage);
        await this.disconnectDirectApi(idPage);
        this.gridData = this.gridData.map(e => {
          if (e.pages.id === idPage) {
            e.pages.story_config = null;
            e.bots[0].page.story_config = null;
          }
          return e;
        });
        await this.fetchPages();
        await this.fetchBots();
        this.$emit('update-multipletable', this.gridData)
        this.$forceUpdate();
      },

      checkEditBotType(type) {
        if(this.editedBotExists){
          switch(type){
            case 'custom':
            case 'none':
              return this.bot.sourceType == 'normal'
            case 'normal':
              return ['custom', 'none'].includes(this.bot.sourceType)
            default:
          }
        }
        return false 
      },

      async closePopup() {
        await this.fetchPages(); 
        this.submitAfterConnection();
      },

      submitAfterConnection() {
        this.$nextTick(() => {
          console.log('submitAfterConnection', !this.editedBotExists, this.linkedinConnected === 'connected');
          if (!this.editedBotExists && this.linkedinConnected === 'connected') {
            if (!this.bot.sources.length) {
                this.bot.sourceType == 'none';
            }
            this.submit('bot', false)
          } else if (this.editedBotExists && this.linkedinConnected === 'connected') {
            this.update(false)
          }
        })
      },

      toggleExpandTabs() {
        // console.log('toggleExpandTabs', this.advancedTabs, !this.advancedTabs)
        // this.advancedTabs = !this.advancedTabs
        // this.$forceUpdate()
        
        console.log('toggleExpandTabs', this.tabsIsMinimize)
        this.$emit('minimizeTabs', !this.tabsIsMinimize)
      },

      contractTabs(type){
        // console.log(type, this.bot.id)
        // if((type == 'form' && this.bot.id)
        //     || (type == 'list' && !this.bot.id))
        //   this.advancedTabs = false
      
        console.log('contractTabs')
        this.$emit('minimizeTabs', true)
      },

      /** check page filter **/
      checkPageFilter(page){
        return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase())
      },

      checkGroupFilter(group){
        if(!group) return false
        return group.pages.every(p => this.findPage(p) && !this.checkPageFilter(this.findPage(p)))
      },

      async connectLinkedin(replaceUsername = false) {
        if (replaceUsername) {
          this.linkedinUsername = this.selectedPage.name;
        }
        console.log(this.linkedinUsername);
        console.log(this.linkedinPassword);
        console.log(this.selectedPage.id);
          
        let body = {
          pageId: this.selectedPage.id,
          usernameAccount: this.linkedinUsername,
          passwordAccount: this.linkedinPassword,
        }
        this.$vs.loading({
          container: '#linkedin-direct-loading',
          scale: 0.6
        });
        this.connectLinkedinDirect(body).then(async response =>  {
            console.log(response);
            this.$vs.loading.close('#linkedin-direct-loading > .con-vs-loading');
          if (response.ok && response.body && response.body.connected) {
            this.usernamePageDiff = (this.selectedPage && this.selectedPage.id !== 'createPage' && response.body.username !== this.selectedPage.name) ? response.body.username : null;
            await this.fetchPages();
            this.linkedinModify = false;
            this.connectionReturn = true;
            this.submitAfterConnection();
          } else if (response.ok && response.body && response.body.twoAuth) {
            this.fetchPages();
            this.twoFactorPopup = this.selectedPage.id
          } else if (response.ok && response.body && response.body.challengeInstagram) {
            if (response.body.id) {
              this.page.id = response.body.id;
            }
            this.fetchPages();
            this.twoFactorPopup = this.page.id;
            // this.$vs.notify({
            // this.notify({
            //   title:'Erreur de connexion',
            //   text: this.$t('dash.bots.two_auth_failed'),
            //   color: 'primary',
            //   time: 10000,
            //   id: this.page.id
            // }, {
            //   component: "Bots",
            //   action: "connectLinkedinDirect",
            //   params: {
            //     pageId: this.page.id,
            //     usernameAccount: this.linkedinUsername,
            //     passwordAccount: 'XXXX',
            //     responseBody: response.body
            //   }
            // });
          } else if (response.ok && response.body && response.body.captcha) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.captcha'),
              color: 'primary',
              time: 10000,
              id: 'repeat'
            }, {
              component: "Bots",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } 
          else if (response.ok && response.body && response.body.badPassword) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.bad_password'),
              color: 'primary',
              time: 8000,
              id: 'repeat'
            }, {
              component: "Bots",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } else if (response.ok && response.body && response.body.invalidUser) {
          // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.invalid_user'),
              color: 'primary',
              time: 8000,
              id: 'repeat'
            }, {
              component: "Conciergerie",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } else if (response.ok && response.body && response.body.csrfToken) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.csrf_token'),
              color: 'primary',
              time: 8000,
              id: 'repeat'
            }, {
              component: "Conciergerie",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } else if (response.ok && response.body && response.body.notImplementedChall) {
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.not_implemented'),
              color: 'primary',
              time: 10000,
              id: 'repeat'
            }, {
              component: "Conciergerie",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response.body
              }
            });
          } else if (!response.ok && response.bodyText && response.bodyText.includes && response.bodyText.includes("560")) {
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: this.$t('dash.bots.2fa_560'),
              color: 'primary',
              time: 5000,
              id: 'repeat'
            }, {
              component: "Bots",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response
              }
            });
          } else if (!response.ok) {
            // this.$vs.notify({
            this.notify({
              title: this.$t('dash.bots.connection_error_title'),
              text: response.bodyText,
              color: 'primary',
              time: 5000,
              id: 'repeat'
            }, {
              component: "Bots",
              action: "connectLinkedinDirect",
              params: {
                pageId: this.page.id,
                usernameAccount: this.linkedinUsername,
                passwordAccount: 'XXXX',
                responseBody: response
              }
            });
          }
        });
      },

    async newBoardofPinterest(){
      if(this.newBoardName){
        //this.$vs.loading({color : 'primary'})      
        this.showLoader = true
        console.log('newBoardofPinterest', this.newBoardName, this.bot.page)
        let bot = []
        bot.id = this.bot.page
        await this.createBoardPinterest(bot,this.newBoardName)
        .then( async (res) => {  
          console.log('board created : ', res)
          if(res.body.board.code)
          {
            //  this.$vs.notify({
            this.notify({
              title:'Erreur',
              text:res.body.board.message,
              color:'success',
              time: 4000,
              id: bot.id
            }, {
              component: "Bots",
              action: "createBoardPinterest",
              params: {
                botId: bot.id,
                newBoardName: this.newBoardName
              }
            })
            //this.$vs.loading.close()
            this.showLoader = false
          }
          else{
          this.boardSelected = res.body.board
          this.boards = await this.getBoardPinterest(bot)
          this.boards = this.boards.body
          console.log('boards maj :', this.boards)
          this.newBoardName = ''
          //this.$vs.loading.close()
          this.showLoader = false

          // this.$vs.notify({
          this.notify({
            title:'Tableau ajouté',
            text:'Le tableau a bien été ajouté à la liste.',
            color:'success',
            time: 4000,
            id: bot.id
          })
        }
        
      })}
      else{
        // this.$vs.notify({
        this.notify({
          title:'Veuillez ajouter un nom au tableau',
          text:'',
          color:'success',
          time: 4000,
          id: 'norepeat'
        })
      }
    },


      async getBase64FromUrl(url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob); 
          reader.onloadend = () => {
            const base64data = reader.result;   
            resolve(base64data);
          }
        });
      },
      getHighlightsInstagramList(page) {
        if (page.network === 'instagram') {
          this.getHighlightsInstagram({id: page.id}).then(res => {
            console.log(res);
            if (!res.ok) {
              this.highlightsPage = [];
            } else {
              this.highlightsPage = res.body.highlights
            }
          });
        }

      },

      initAfterAutoPost(){
        const { id, name, network } = this.pages.find(x => x.id === this.bot.page) || {}

        this.getAllPagesWithBot.forEach(page => {
          let action = {
            active: false,
            page: page.id,
            frequency: {
              custom: false,
              value: 60
            }
          }
          if(!this.bot.afterAutoPost.repostAuto.find(r => r.page == page.id))
            this.bot.afterAutoPost.repostAuto.push(action)
          if(network == 'twitter' && !this.bot.afterAutoPost.retweetAuto.find(r => r.page == page.id))
            this.bot.afterAutoPost.retweetAuto.push(action)
          if(network != 'twitter' && !this.bot.afterAutoPost.reshareAuto.find(r => r.page == page.id))
            this.bot.afterAutoPost.reshareAuto.push(action)
        })
      },

      addSharedStory(e) {
        console.log(e.target.checked, this.selectedPage.id);
        if (e.target.checked) {
          this.bot.afterAutoPost.story = {shared: true, visual: false, page: this.selectedPage.id};
        } else {
          this.bot.afterAutoPost.story = null;
        }
        console.log(this.bot.afterAutoPost)
      },

      addAfterAutoPost(type, page){
        let action = {
          active: true,
          page: page.id,
          frequency: {
            custom: false,
            value: 60
          }
        }
        switch(type){
          case 'retweet':
            this.bot.afterAutoPost.retweetAuto.push(action)
            break
          case 'reshare':
            this.bot.afterAutoPost.reshareAuto.push(action)
            break
          case 'repost':
            this.bot.afterAutoPost.repostAuto.push(action)
            break
          default:
            break
        }
      },

      getPage(id){
        return this.pages.find(page => page.id == id)
      },

      addMention(){
        if(!this.bot.mentions) this.bot.mentions = []
        this.bot.mentions.unshift({ mention: '', correspondence: '', correspondences: [] });
      },

      removeMention(key){
        //console.log('key', key, this.bot.mentions)
        this.bot.mentions.splice(key, 1)
      },

      addHashtag(){
        if(!this.bot.hashtagsAuto) this.bot.hashtagsAuto = []
        this.bot.hashtagsAuto.unshift({ hashtag: '', correspondence: '', correspondences: [] });
      },

      checkAndAddCorrespondance(key, type, newTag){   
        let checkMentions = this.bot.mentions.filter(m => m.correspondences.find(mc => mc && mc.toLowerCase() == newTag.tag.text.toLowerCase())) || false
        let checkHashtags = this.bot.hashtagsAuto.filter(h => h.correspondences.find(hc => hc && hc.toLowerCase() == newTag.tag.text.toLowerCase())) || false

        if(checkMentions.length || checkHashtags.length){
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.error.title'),
            text: this.$t('dash.bots.error.duplicate_correspondence'),
            color: 'primary',
            id: this.bot.id
          })
          switch(type){
            case 'mention':
              this.bot.mentions[key].correspondence = ""
              break
            case 'hashtag':
              this.bot.hashtagsAuto[key].correspondence = ""
              break
          }
        }
        else {
          newTag.addTag()
          switch(type){
            case 'mention':
              this.bot.mentions[key].correspondences.push(newTag.tag.text)
              break
            case 'hashtag':
              this.bot.hashtagsAuto[key].correspondences.push(newTag.tag.text)
              break
          }
        }
      },

      removeCorrespondance(key, type, removeTag){
        removeTag.deleteTag()
        switch(type){
          case 'mention':
            this.bot.mentions[key].correspondences.splice(removeTag.index, 1)
            break
          case 'hashtag':
            this.bot.hashtagsAuto[key].correspondences.splice(removeTag.index, 1)
            break
          case 'inclusion':
            this.bot.inclusion.tags.splice(removeTag.index, 1)
            break
          case 'exclusion':
            this.bot.exclusion.tags.splice(removeTag.index, 1)
            break
        }
        
      },

      removeHashtag(key){
        this.bot.hashtagsAuto.splice(key, 1)
      },

      findVanityNameByUrl(url){
        if(url && new URL(url) && new URL(url).pathname.includes('/company/')){
          return  new URL(url).pathname.replace('/company/', '').replace('/', '')
        }
        return ''
      },

      findInstagramUserByUrl(url){
        if(url && url.includes('https://www.instagram.com/')){
          return url.replace('https://www.instagram.com/', '').replace('/', '')
        }
        return ''
      },

      async searchMentions(key){
        this.openAutoMentions = false
        // eslint-disable-next-line no-useless-escape
        const urlRegex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
        const isUrl = urlRegex.test(this.bot.mentions[key].mention);
        let mention = this.selectedPage.network == 'linkedin' && (this.linkedinConnected !== 'connected' || isUrl)
                            ? this.findVanityNameByUrl(this.bot.mentions[key].mention)
                            : (this.selectedPage.network == 'instagram'  && (this.linkedinConnected !== 'connected' || isUrl)
                                ? this.findInstagramUserByUrl(this.bot.mentions[key].mention)
                                : this.bot.mentions[key].mention)

        setTimeout(async () => { 
          let currentMention = this.selectedPage.network == 'linkedin' && (this.linkedinConnected !== 'connected' || isUrl)
                            ? this.findVanityNameByUrl(this.bot.mentions[key].mention)
                            : (this.selectedPage.network == 'instagram' && (this.linkedinConnected !== 'connected' || isUrl)
                                ? this.findInstagramUserByUrl(this.bot.mentions[key].mention)
                                : this.bot.mentions[key].mention)
          //user stop typing
          if(mention == currentMention){
            if(mention.length >= 2){
              //console.log('get mentions by api')
              let needSimulate = false;
              if (this.bot.page.network === 'instagram') {
                let simulate = localStorage.simulateInstagram;
                console.log("Simulate", simulate);
                let currentPageId = this.bot.page.id;
                if (!simulate) {
                  needSimulate = true;
                  localStorage.setItem('simulateInstagram', JSON.stringify({[currentPageId]: Date.now()}))
                } else {
                  simulate = JSON.parse(simulate)
                  let currentSimulate = simulate[currentPageId];
                  if (!currentSimulate ||  Math.floor(Math.abs(Date.now() - currentSimulate) / (1000 * 60)) > 10) {
                    needSimulate = true;
                    simulate[currentPageId] = Date.now();
                    localStorage.setItem('simulateInstagram', JSON.stringify(simulate))
                  }
                }
              }
              console.log("NEED SIMULATE", needSimulate);
              await this.getMentionsByApi(this.bot.page, mention, isUrl, needSimulate)
              .then((res) => {  
                console.log('searchMentions', this.selectedPage.network, key, mention, currentMention, res)  
                if(res.body.word == currentMention)  {  
                  console.log('OK',this.autoMentions[key]) 
                  this.autoMentions[key] = Object.values(res.body.mentions).map(m => {
                    switch(this.selectedPage.network){
                      case 'twitter':
                        return {
                          // id: m.id_str,
                          // name: m.name,
                          // screen_name: m.screen_name,
                          // description: m.description,
                          // location: m.location,
                          // image: m.profile_image_url_https,
                          // verified: m.verified

                          id: m.id,
                          name: m.name,
                          screen_name: m.username,
                          description: m.description,
                          location: m.location,
                          image: m.profile_image_url,
                          verified: m.verified_type
                        }
                      case 'facebook':
                        return {
                          id: m.id,
                          name: m.name,
                          image: m.image && m.image.data && m.image.data.url ? m.image.data.url : null
                        }
                      case 'linkedin':
                      case 'instagram':
                        return m
                      default:
                        break
                    }
                  })
                  if(this.selectedPage.network == 'facebook') {
                    this.queue = new Queuer({
                      data: JSON.parse(JSON.stringify(this.autoMentions[key])),
                      task:(m) => {
                        let ind = this.autoMentions[key].findIndex(c => c.id == m.id)
                        this.getAvatarMentionByApi(this.selectedPage.id, m.id).then((res) => {
                          if(res && res.body && res.body.avatar && res.body.avatar.data && res.body.avatar.data.url)
                            this.$set(this.autoMentions[key][ind], 'image', res.body.avatar.data.url)
                            this.$forceUpdate()
                          this.queue.unlock()
                        })
                      }
                    })
                    this.queue.init()
                  }
                  if(this.selectedPage.network == 'twitter'){
                    //filter last entry null
                    this.autoMentions[key] = this.autoMentions[key].filter(m => m.screen_name)
                  }
                  //open proposition
                  if(this.autoMentions[key].length > 0)
                    this.openAutoMentions = true
                  //console.log('autoMentions', this.autoMentions)
                }
              })
            }
          }
        }, 250);
      }, 

      replaceMention(key, mention) {
        switch(this.selectedPage.network){
          case 'twitter':
            this.bot.mentions[key].mention = mention.screen_name
            break
          case 'facebook':
            this.bot.mentions[key].mention = `${mention.name} (${mention.id})`
            break
          case 'linkedin':
            this.bot.mentions[key].mention = `${mention.name} ("${mention.id}")`
            break
          case 'instagram':
            if (mention.id) {
              this.bot.mentions[key].mention = `${mention.id}`
            } else {
              this.bot.mentions[key].mention = `${mention.name}`
            }
            break
        }
        this.openAutoMentions = false
      },

      closeAutoMentions(){
        //console.log('closeAutoMentions')
        this.openAutoMentions = false
      },

      showAutoMentions(key){
        //console.log('showAutoMentions', key)
        //this.openAutoMentions = true
        this.searchMentions(key)
        //init automentions of others mentions
        for(let i=0; i<this.autoMentions.length; i++){
          if(i != key)
            this.autoMentions[i] = []
        }
        
      },

      /**
       * Prepare page for bot creation.
       * @param {Object} opt - Optional information to fill the new bot with.
       */
      async initBot(opt = {}) {
        this.bot = { ...this.defaultBot, ...opt }
        // Get page information
        if (!this.pages) {
          await this.fetchPages()
        }
        const { id, name, network } = this.pages.find(x => x.id === this.bot.page) || {}
        // Check the user can edit the bot
        if (network && !this.checkLock(network)) {
          this.notifyNotPremium()
          return
        }

        this.bot.name = `${name} ${network} ${this.bots.filter(b => b.page.id == id).length + 1}`

        //this.initAfterAutoPost()

        //this.bot.sourceType = 'normal'
        //this.bot.sourceType = this.checkLock('source_choice') && !this.checkLock('partner') ? 'custom' : 'normal'
        this.bot.sourceType = this.checkLock('source_choice') && !JSON.parse(localStorage.user).partner ? 'custom' : 'normal'
        this.bot.topics.theme = null
        this.bot.topics.category = null

        this.bot.utmCampaign = '' //"post-auto"
        this.bot.utmMedium = '' //network
        this.bot.utmSource = ''
        //const newUtmParams = new URLSearchParams()
        //newUtmParams.set("utm_campaign", this.bot.utmCampaign)
        //newUtmParams.set("utm_medium", this.bot.utmMedium)
        //newUtmParams.set("utm_source", this.bot.utmSource)
        this.bot.utm = '' //newUtmParams.toString()

        this.bot.limit = this.checkLock('posts_limit')
        //if plan 0 (free)
        if(!this.checkLock('bots_daily') && !this.checkLock('partner')){
          //limit to only one bot
          if(this.bots.length >= 1){
            this.notifyNotPremium('dash.bots.cannot_add')
            return
          }
          //limit to 3 posts/day 
          //this.bot.limit = this.checkLock('posts_limit')
          this.showLimit = 'true'
        }

        this.planning()

        if(!this.bot.mentions) this.bot.mentions = []
        if(this.bot.mentions.length == 0) this.addMention()

        if(!this.bot.hashtagsAuto) this.bot.hashtagsAuto = []
        if(this.bot.hashtagsAuto.length == 0) this.addHashtag()

        if(['twitter', 'instagram', 'facebook', 'linkedin'].includes(network))
          this.bot.posts.mode = 'standard' 

        this.$router.push('/dash/bots/new')
      },

      async fetchPages() {
        return this.getPages()
                   .then(res => {
                     console.log(res.body)
                     const { pages } = res.body
                     // TODO remove this once it wont be used
                     localStorage.setItem('pages', JSON.stringify(pages))
                     this.pages = pages
                       .sort((page1, page2) => {
                         const [d1, d2] = [page1, page2].map(x => new Date(x.updated_at))
                         if (d1 < d2) return -1
                         if (d1 > d2) return +1
                         return 0
                       })
                   })
      },

      /**
       * Retrieve bots from database and cache them.
       */
      async fetchBots() {
        try {
          // Get bot list from server
          const { body, statusText } = await this.getAllBots({})
          const { success, bots } = body
          if (!success) {
            throw Error(statusText)
          }
        
          // Initiate the sources prop on each bot. Normal bots should have an empty array in sources
          bots.map(b => b.sources = this.sources.sourceList.filter(s => b.flux.includes(s.uid)))
          this.bots = bots
          //for (const i in bots) this.$set(this.bots, i, bots[i])
          // TODO remove this later when it won't be used
          await localStorage.setItem('bots', JSON.stringify(bots))

          // Show invitation to create a bot if none
          if (!bots || !bots.length)
            this.$emit('on-show-onboarding', 1)

          // Save data
        } catch (err) {
          return this.handleError(err)
        }
      },

      async orderedPages(){
        
        let grid = await Object.values(this.linkedPages)
        .map(v => ({
          pages: v,
          bots: this.bots.filter(bot => bot.page.id === v.id)
          // bots: this.showEnabledBots
          //             ? this.bots.filter(bot => bot.page.id === v.id && (bot.frequency || ((bot.flux && bot.flux.length) || bot.category)))
          //             : this.bots.filter(bot => bot.page.id === v.id && (!bot.frequency && ((bot.flux && !bot.flux.length) && !bot.category)))
        }))

        // grid = grid.filter(g => g.bots.length)
        // if(!this.showEnabledBots) {
        //   let pages = this.linkedPages
        //     .filter(v => !this.bots.find(b => b.page.id === v.id))
        //     .map(v => ({
        //           pages: v,
        //           bots: []
        //          })
        //     )
        //   grid = grid.concat(pages)
        // }

        this.keyListBots = Math.floor(Math.random()*1000)

        // grid = grid.filter(g => this.showEnabledBots 
        //                               ? g.bots.length
        //                               : this.bots.filter(bot => bot.page.id === g.id))

        //sort by bots active and pages name
        grid = await grid.slice().sort((a,b) => {
          if((a.bots.length == 0 && b.bots.length == 0) || (a.bots.length > 0 && b.bots.length > 0)){
            return (a.pages.name > b.pages.name) ? 1 : ((a.pages.name < b.pages.name) ? -1 : 0)
          }
          else if(a.bots.length > 0){
            return -1
          }
          else if(b.bots.length > 0){
            return 1
          }
        })
        //sort by bots name
        grid = await Object.values(grid).map(g => ({
          pages: g.pages,
          bots: g.bots.sort((a,b) => (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0))
        }))
        //sort bots by updated_at 
        grid = await Object.values(grid).map(g => ({
          pages: g.pages,
          bots: g.bots.sort((a,b) => (a.updated_at < b.updated_at) ? 1 : ((a.updated_at > b.updated_at) ? -1 : 0))
        }))
        //sort pages by bots updated_at 
        grid = await grid.slice().sort((a,b) => {
          if(a.bots.length == 0 && b.bots.length == 0) return 0 
          else if(a.bots.length > 0 && b.bots.length == 0) return -1
          else if(a.bots.length == 0 && b.bots.length > 0) return 1
          else if(a.bots[0].updated_at < b.bots[0].updated_at) return 1
          else if(a.bots[0].updated_at > b.bots[0].updated_at) return -1
          else return 0
        })
        this.gridData = grid
        this.selectedPages = this.gridData.map(d => d.pages)
      },

      fetchGroups() {
        let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
        this.getGroups().then(res => {
          console.log('getGroups', res)
          this.groups = res.map(group => {
            // return {...group, show: true}
            return {...group, show: !hideGroups.find(g => g == group.id)}
          })
          this.selectedGroups = this.groups.map(g => g.id)
        })
      },

      toggleShowGroup(group) {
        let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
        if(group.show)
          hideGroups.push(group.id)
        else 
          hideGroups = hideGroups.filter(g => g != group.id)
        localStorage.setItem('hideGroups', JSON.stringify(hideGroups))
        
        let index = this.groups.findIndex(g => g.id == group.id)
        this.$set(this.groups[index], 'show', !group.show)
      },

      findPage(pageId) {
        let bot = this.gridData.find(p => p.pages.id == pageId)
        return bot && bot.pages ? bot.pages : null
      },

      pageInGroup(page) {
        return this.groups.find(g => g.pages.includes(page.id))
      },

      checkPagesInGroup(group) {
        return group.pages.some(p => this.findPage(p))
      },

      checkGroup(group){
        if(this.selectedGroups.includes(group.id)){
          // this.selectedPages = this.selectedPages.concat(this.gridData.map(g => g.pages).filter(p => group.pages.includes(p.id)))
          this.selectedPages = this.gridData.map(g => g.pages).filter(p => group.pages.includes(p.id))
          this.selectedGroups = [group.id]
        }
        else {
          this.selectedPages = this.selectedPages.filter(p => !group.pages.includes(p.id))
        }
      },

      /**
       * Create new bot
       */
      async submit(scope, redirection=true) {
        this.$validator.validateAll(scope).then(async result => {
          if (!result && this.$validator.errors.items.length)
            return

          this.convertPlanningToUtc()

          if (this.templateStory && this.templateStory.highlight === '__new_highlight__') {
            this.templateStory.highlight = this.newHighlight;
          }

          if (this.templateMode === 'manual' && this.bot.posts.mode == "story") {
            this.templateStory.configuration = await this.$refs.templateMaker.getTemplateInformations();
            console.log(this.templateStory.configuration);
          }
          console.log('boardSelected : ', this.boardSelected)

          const body = {
            name: this.bot.name,
            page: this.selectedPage.id,
            type: this.selectedPage.network,
            domain: this.bot.topics.theme
              ? this.bot.topics.theme.url
              : VUE_APP_DASHBOARD_API,
            service: this.bot.topics.theme
              ? this.bot.topics.theme.name
              : 'dashboard',
            category: this.bot.topics.category,
            utm_source:
              this.bot.utm.length > 0
                ? this.bot.utm
                : null,
                  // TODO really keep this?
                  //slug('utm mashup ' + this.selectedPage.name, '_').toLowerCase(),
            hashtag: this.bot.hashtag,
            hashtagPrefix: this.bot.hashtagPrefix,
            instant: this.bot.frequency.value == 'instant' ? true : false,
            frequency: this.bot.frequency.value != 'instant' ? this.bot.frequency.value : 0,
            whitelist: this.bot.sourceType === 'normal' ? [...this.selectedSources] : [],
            flux:
              this.bot.sourceType === 'normal' || this.bot.sourceType === 'none' ? undefined : [...this.selectedSources],
            locale: this.bot.topics.lang,
            capping: this.bot.limit,
            status: 1,
            post_text_layout: this.bot.posts.display,
            //media: this.bot.posts.content,
            media: ["photo","video","text"],
            tags: this.bot.inclusion.tags.map(x => x.text),
            tags_excluded: this.bot.exclusion.tags.map(x => x.text),
            planning: this.bot.planning,
            timezoneOffset: -new Date().getTimezoneOffset(),
            mentions: this.getMentions,
            hashtagsAuto: this.getHashtagsAuto,
            afterAutoPost: this.bot.afterAutoPost,
            instagramUsername: this.bot.instagram.credentials.username,
            instagramPassword: this.bot.instagram.credentials.password,
            network_id: this.selectedPage.network_id,
            instagramType: this.bot.posts.mode,
            storyTemplate: this.templateStory,
            boardPinterest: this.boardSelected,
            mode: this.bot.posts.mode || 'standard'
          }

          this.$ga.event('bots', 'create')
          //this.$vs.loading({ color: 'primary' })
          this.showLoader = true
          this.createBot(body).then(async res => {
            const { success, bot } = res.body

            if(this.activeLog){
              let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
              this.addLog(JSON.parse(localStorage.user), 'create-bot', messageLog)
            }

            //this.$vs.loading.close()
            this.showLoader = false
            if (!success || success !== true) {
              const { code } = res.body[0].error
                ? res.body[0].error
                : res.body[0].reason;
              const errBody = code
                ? `dash.notifications.${code}`
                : 'dash.bots.error.description'

              // this.$vs.notify({          
              this.notify({
                title: this.$t('dash.bots.error.title'),
                text: this.$t(errBody),
                color: 'primary',
                id: 'norepeat'
              }, {
                component: "Bots",
                action: "createBot",
                params: {
                  ...body
                }
              })
              return
            }
            this.$vs.dialog({
              color: 'primary',
              title: this.$t('dash.notifications.success_title'),
              text: this.$t('dash.bots.success.created_description'),
              acceptText: "OK"
            })

            // Update main view
            bot.page = this.linkedPages.find(x => x.id === bot.page)
            this.$set(this.bots, this.bots.length, bot)
            await this.fetchBots()
            await this.orderedPages()
            if (redirection) {
              this.$router.replace('/dash/bots')
              
              this.$emit('on-close-bot-form')
              localStorage.setItem('last_selected_page', JSON.stringify(this.selectedPage))      
              localStorage.setItem('last_selected_pages', JSON.stringify([this.selectedPage]))
            }
            
          })
        })
      },

      /**
       * Submit new bot
       */
      async update(redirection=true) {
        localStorage.setItem('last_selected_page', JSON.stringify(this.selectedPage))
        localStorage.setItem('last_selected_pages', JSON.stringify([this.selectedPage]))

        let page = this.selectedPage
        let domain = this.bot.topics.theme.url
        let service = this.bot.topics.theme.name

        // When changed
        let category = this.bot.topics.category
        let hashtag = this.bot.hashtag
        let hashtagPrefix = this.bot.hashtagPrefix
        let locale = this.bot.topics.lang
        let frequency = this.bot.frequency.value
        let sources = [...this.selectedSources]
        let capping = this.bot.limit
        let post_text_layout = this.bot.posts.display
        //let media = this.bot.posts.content
        let media = ["photo","video","text"]
        let id = this.bot.id
        let utm =
              this.bot.utm.length > 0
                ? this.bot.utm
                : null //slug('utm mashup ' + page.name, '_').toLowerCase()

        this.convertPlanningToUtc()


        if (this.templateStory && this.templateStory.highlight === '__new_highlight__') {
          this.templateStory.highlight = this.newHighlight;
        }

        if (this.templateMode === 'manual' && this.bot.posts.mode == "story") {
            this.templateStory.configuration = await this.$refs.templateMaker.getTemplateInformations();
            console.log(this.templateStory.configuration);
        }

        let body = {
          name: this.bot.name,
          page: page.id,
          type: page.network,
          domain: domain,
          service: service,
          category: category,
          utm_source: utm,
          hashtag: hashtag,
          hashtagPrefix: hashtagPrefix,
          //frequency: frequency,
          instant: frequency == 'instant' ? true : false,
          frequency: frequency != 'instant' ? frequency : 0,
          whitelist: sources,
          locale: locale,
          capping: capping,
          status: 1,
          post_text_layout: post_text_layout,
          id: id,
          media: media,
          planning: this.bot.planning,
          timezoneOffset: -new Date().getTimezoneOffset(),
          mentions: this.getMentions,
          hashtagsAuto: this.getHashtagsAuto,
          afterAutoPost: this.bot.afterAutoPost,
          mode: this.bot.posts.mode || 'standard',
          network_id: this.selectedPage.network_id,
          instagramUsername: this.bot.instagram.credentials.username,
          instagramPassword: this.bot.instagram.credentials.password,
          instagramType: this.bot.posts.mode,
          storyTemplate: this.templateStory,
          boardPinterest: this.boardSelected,
        }

        if (this.bot.sourceType == 'custom') {
          body.flux = body.whitelist
          body.whitelist = []
        }
        else if(this.bot.sourceType == 'none'){
          body.flux = []
          body.whitelist = []
        }

        if (this.bot.inclusion.tags.length) {
          body.tags = this.bot.inclusion.tags.map(x => x.text)
        }
        else {
          body.tags = [];
        }

        if (this.bot.exclusion.tags.length) {
          body.tags_excluded = this.bot.exclusion.tags.map(x => x.text)
        }
        else {
          body.tags_excluded = [];
        }

        //this.$vs.loading({ color: 'primary' })
        this.showLoader = true
        this.$ga.event('bots', 'update')
        const res = await this.modifyBot(body)
        const { success, bot, code } = res.body

        if(this.activeLog){
          let messageLog = `${res.url} --- ${JSON.stringify(body)} --- ${res.bodyText}`
          this.addLog(JSON.parse(localStorage.user), 'update-bot', messageLog)
        }

        //this.$vs.loading.close()
        this.showLoader = false
        if (!success || success !== true) {
          const { code } = res.body[0].error
                ? res.body[0].error
                : res.body[0].reason;
          const errBody = code
            ? `dash.notifications.${code}`
            : 'dash.bots.error.description'

          console.log(code, errBody, this.$t(errBody))
          // this.$vs.notify({
          this.notify({
            title: this.$t('dash.bots.error.title'),
            text: this.$t(errBody),
            color: 'primary',
            id: page.id
          }, {
              component: "Bots",
              action: "modifyBots",
              params: {
                ...body
              }
            })
          return
        }
        this.$vs.dialog({
          color: 'primary',
          title: this.$t('dash.notifications.success_title'),
          text: this.$t('dash.bots.success.updated_description'),
          acceptText: "OK"
        })

        // Update main view
        const initialBot = this.bots.find(x => x.id === bot.id)
        let index = this.bots.indexOf(initialBot)

        // Update main view
        const botPage = this.linkedPages.find(x => x.id === initialBot.page.id)
        bot.page = botPage

        this.$set(this.bots, index, bot)
        localStorage.setItem('bots', JSON.stringify(this.bots))


        await this.fetchBots()
        await this.orderedPages()
        this.$emit('update-multipletable', this.gridData)

        if (redirection) {
          this.cleanData()
          this.$emit('on-close-bot-form')
        }
        
        
      },

      convertPlanningToUtc(){
        let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        //convert planning to UTC
        let planning = {}
        for (let day in this.bot.planning) planning[day] = {}
        for (let day in this.bot.planning) {
          for (let hour in this.bot.planning[day]) {
            let hourUTC = new Date(new Date().setHours(hour)).getUTCHours()
            let dayUTC = day
            if(parseInt(hourUTC) > parseInt(hour)){
              //yesterday
              dayUTC = days[days.indexOf(day)-1]
              if(!dayUTC) dayUTC = days[days.length-1]
            }
            planning[dayUTC][hourUTC] = this.bot.planning[day][hour] ? true : false
          }
        }
        this.bot.planning = planning
      },

      convertPlanningToLocale(){
        let days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        //convert planning to locale
        let planning = {}
        for (let day in this.bot.planning) planning[day] = {}
        for (let day in this.bot.planning) {
          for (let hour in this.bot.planning[day]) {
            let hourLocale = new Date(new Date().setUTCHours(hour)).getHours()
            let dayLocale = day
            if(parseInt(hourLocale) < parseInt(hour)){
              //tomorrow
              dayLocale = days[days.indexOf(day)+1]
              if(!dayLocale) dayLocale = days[0]
            }
            planning[dayLocale][hourLocale] = this.bot.planning[day][hour] ? true : false
          }
        }
        this.bot.planning = planning
      },

      changeUtmValue(type, event) {
        let utmParams = new URLSearchParams(this.bot.utm)
        switch(type){
          case 'utm_campaign':
            this.bot.utmCampaign = event.target.value;
            break
          case 'utm_medium':
            this.bot.utmMedium = event.target.value;
            break
          case 'utm_source':
            this.bot.utmSource = event.target.value;
            break
        }
        event.target.value == ''
          ? utmParams.delete(type)
          : utmParams.set(type, event.target.value) 
    
        this.bot.utm = utmParams.toString()
      },

      editBot(id) {
        // Get Bot data from its id
        let bot = this.bots.find(x => x.id === id)
        console.log('bot', bot)

        if (!bot) {
          this.handleError({
            title: 'Invalid internal bot representation',
            message: 'This shoud not happen. Please contact support.'
          })
        }

        // Check the user can edit the bot
        if (!this.checkLock(bot.page.network) || (!this.isUserPremiumActive && !this.gridData[0].bots.find(x => x.id === id) && !this.isUserPartner)) {
          this.notifyNotPremium()
          return
        }

        //init bot
        this.bot = { ...this.defaultBot }
        this.linkedinModify = false
        this.linkedinUsername = ''
        this.linkedinPassword = ''
        this.twoFactorPopup = false
        this.newHighlight = ''
        this.highlightsPage = []
        this.modeInsta = 'standard'
        this.templateMode = 'manual'
        this.templateStory = {
          configuration: null,
          highlight: null,
          predefined: null,
        }

        let page = this.linkedPages.find(x => x.id === bot.page.id)

        this.getHighlightsInstagramList(page);

        this.bot.id = id
        this.bot.page = page.id
        this.bot.name = bot.name
        this.bot.topics.theme = { name: bot.service, url: bot.domain }
        this.bot.topics.category = bot.category
        this.bot.topics.lang = bot.locale
        this.bot.hashtag = bot.hashtag
        this.bot.hashtagPrefix = bot.hashtagPrefix
        this.bot.limit = bot.capping
        this.bot.utm = bot.utm_source
        if (bot.storyTemplate) {
          this.templateStory = {
            configuration: bot.storyTemplate.configuration || null,
            highlight: bot.storyTemplate.highlight,
            predefined: bot.storyTemplate.predefined || null
          }
          if(bot.storyTemplate.boardPinterest){
          this.templateStory.boardPinterest = bot.storyTemplate.boardPinterest
          }
          if (bot.storyTemplate.predefined) {
            this.templateMode = 'auto';
          } else {
            this.templateMode = 'manual';
          }
        }
        
        //this.bot.utmCampaign = "post-auto"
        //this.bot.utmMedium = bot.page.network
        this.bot.utmCampaign = ''
        this.bot.utmMedium = ''
        this.bot.utmSource = ''
        const utmParams = new URLSearchParams(bot.utm_source)
        for (const [k, v] of utmParams) {
          switch(k){
            case 'utm_campaign':
              this.bot.utmCampaign = v
              break;
            case 'utm_medium':
              this.bot.utmMedium = v
              break;
            case 'utm_source':
              this.bot.utmSource = v
              break;
            default:
              this.bot.utmSource = k
          }
        }
        const newUtmParams = new URLSearchParams()
        if(this.bot.utmCampaign != '') newUtmParams.set("utm_campaign", this.bot.utmCampaign)
        if(this.bot.utmMedium != '') newUtmParams.set("utm_medium", this.bot.utmMedium)
        if(!!this.bot.utmSource || this.bot.utmSource != '') newUtmParams.set("utm_source", this.bot.utmSource)
        this.bot.utm = newUtmParams.toString()

        if(bot.tags)
          this.bot.inclusion.tags = bot.tags.map(s => ({
            text: s,
            tiClasses: ['valid']
          }))
        if(bot.tags_excluded)
          this.bot.exclusion.tags = bot.tags_excluded.map(s => ({
            text: s,
            tiClasses: ['valid']
          }))

        this.setTheme()

        if (this.bot.limit && this.bot.limit > 0) this.showLimit = 'true'

        if(!this.checkLock('bots_daily') && !this.checkLock('partner')){
          this.bot.limit = 3
          this.showLimit = 'true'
        }

        this.bot.sources = bot.sources

        /*this.bot.sourceType = 'normal'
        if (bot.flux.length || bot.service == 'dashboard') 
          this.bot.sourceType = 'custom'
        if(!bot.whitelist.length || !bot.flux.length)
          this.bot.sourceType = 'none'*/

        this.bot.sourceType = 'none'
        if (bot.flux.length) 
          this.bot.sourceType = 'custom'
        else if(bot.whitelist.length || bot.category)
          this.bot.sourceType = 'normal'



        this.bot.whitelist = bot.whitelist
        this.bot.frequency = { custom: false, value: bot.instant ? 'instant' : bot.frequency }

        // to check with data
        if (!bot.post_text_layout) {
          this.bot.posts.display = 'none'
        } else {
          this.bot.posts.display = bot.post_text_layout
        }
        this.bot.posts.media = bot.media

        if(['twitter', 'instagram', 'facebook', 'linkedin'].includes(page.network))
          this.bot.posts.mode = bot.mode || 'standard' 
        else 
          this.bot.posts.mode = null
        this.modeInsta = this.bot.posts.mode
        this.$router.replace('/dash/bots/edit')
        if (bot.service) {
          this.bot.topics.theme.name = bot.service
        }
        if (bot.category) {
          this.bot.topics.category.name = bot.category.name
        }

        if(bot.planning) this.bot.planning = bot.planning
        else this.planning()
        this.convertPlanningToLocale()

        this.bot.mentions = [];

        if(bot.mentions && Array.isArray(bot.mentions)) this.bot.mentions = bot.mentions.filter(m => m.mention != '' && m.correspondences.length > 0)
        if(this.bot.mentions.length == 0) this.addMention()

        if(bot.hashtagsAuto && Array.isArray(bot.hashtagsAuto)) this.bot.hashtagsAuto = bot.hashtagsAuto.filter(hashtagAuto => hashtagAuto.hashtag != '' && hashtagAuto.correspondences.length > 0)
        if(this.bot.hashtagsAuto.length == 0) this.addHashtag()

        if(bot.afterAutoPost) this.bot.afterAutoPost = bot.afterAutoPost

        //scroll to top
        window.scrollTo(0,0)

        console.log('test bot', this.bot)
        //this.initAfterAutoPost()
        this.$nextTick(() => {
          if (this.scrollId) {
            document.getElementById(this.scrollId).scrollIntoView(true);
          }
        })

      },

      /**
       * Change edit form
       */
      cleanData() {
        this.$router.replace('/dash/bots')
        this.bot = JSON.parse(JSON.stringify(this.defaultBot)) // True deepcopy
        this.manualName = false
        this.$emit('on-close-bot-form')
      },

      /**
       * Delete
       */
      removeBot() {
        this.$ga.event('bots', 'delete')
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: this.$t('dash.bots.delete.title'),
          text: this.$t('dash.bots.delete.description'),
          acceptText: "OK",
          accept: () => {
            //this.$vs.loading({ color: 'primary' })
            this.showLoader = true

            this.deleteBot(this.bot.id).then(async res => {
              //this.$vs.loading.close()
              this.showLoader = false
              const { success, deleted } = res.body

              if (!success || success !== true) {
                this.dialog.title = 'Error'
                if (!res.body) {
                  this.dialog.message = 'Server not responding…'
                } else {
                  this.dialog.message = res.body.statusText
                }
                this.dialog.show = true
                return
              }

              if (deleted) {
                let initialBot = this.bots.find(x => x.id === this.bot.id)
                let index = this.bots.indexOf(initialBot)
                if (index !== -1) {
                  this.bots.splice(index, 1)
                  await this.orderedPages()
                }
                localStorage.setItem('bots', JSON.stringify(this.bots))
                this.cleanData()
              }
            })
          }
        })
      },

      /**
       * toggle the all sources hack
       * @todo REMOVE THAT ASAP
       */
      toggleAllSources() {
        this.allSourcesBtnSelect = !this.allSourcesBtnSelect
        if (this.allSourcesBtnSelect) this.bot.sources = []
      },

      /**
       * Get custom sources
       */
      async fetchSources() {
        try {
          const { body, statusText } = await this.listSources({})
          const { success, sources } = body
          if (!success)
            throw Error(statusText)

          // Keep sources in global scope
          localStorage.setItem('sources', JSON.stringify(sources))
          this.newSources = sources
          this.sources.sourceList = sources
          await this.loadSources()
        } catch (err) {
          this.handleError(err)
        }
      },
      /**
       * Get custom sources on adding sources
       */
      async fetchSourcesNew() {
        try {
          const { body, statusText } = await this.listSources({})
          const { success, sources } = body
          if (!success)
            throw Error(statusText)

          this.newSources = sources
          localStorage.setItem('sources', JSON.stringify(sources))
          //select new source in the bot
          this.bot.sources.push(sources[sources.length-1])
        } catch (err) {
          this.handleError(err)
        }
      },

      /**
       * Filter List by Sources
       */
      async filterList(query) {
        await this.loadSources(query)
      },

      /**
       * Load sources and handle current selected bot
       */
      async loadSources(keyword = '') {
        if (
          this.bot.topics.theme &&
          !!this.bot.topics.theme.name.length &&
          this.bot.topics.theme.name != 'dashboard' &&
          !!this.bot.topics.lang.length &&
          this.bot.sourceType == 'normal'
        ) {
          try {
            const { body, statusText } = await this.searchSources(
              this.bot.topics.theme.name,
              this.bot.topics.lang,
              keyword,
              keyword.length || !this.bot.topics.category
                ? null
                : this.bot.topics.category.id
            )
            const { success, sources } = body
            if (!success) {
              throw Error(statusText)
            }
            // Update sources
            this.sources.filteredSourceList = sources
          } catch (err) {
            return this.handleError(err)
          }
        }
        // Else get the sources from the bot's custom sources
        else {
          this.sources.filteredSourceList = this.sources.sourceList
        }
        if (this.bot.whitelist.length) {
          this.bot.sources = []
          const srcFilter = src => {
            return src && src.name && src.id && this.bot.whitelist.includes(src.id)
          }
          this.bot.sources = this.sources.filteredSourceList.filter(srcFilter)
        }

        this.allSourcesBtnSelect = this.bot.sourceType == 'normal' && !this.bot.sources.length
      },

      removeSource(...sources) {
        const sourcesIds = sources.map(src => src.id)
        this.bot.sources = this.bot.sources.filter(
          src => !sourcesIds.includes(src.id)
        )
      },

      /**
       * Topics - Get services
       */
      async fetchThemes() {
        try {
          const { body, statusText } = await this.services({ language: this.bot.topics.lang || '' })
          const { services, success } = body
          if (!success) {
            throw Error(statusText)
          }
          this.themes = []
          this.themes.push(
            ...Object.entries(services).map(([name, url]) => ({
              id: 1,
              name,
              url
            }))
          )
        } catch (err) {
          this.handleError(err)
        }
      },

      /**
       * Scroll pages section on left arrow click
       */
      left() {
        let pages = document.querySelector('.linked-pages')
        let number = 2
        let pageOutterWidth = 124 + 10 // page width + margin
        let end = pages.scrollLeft + number * pageOutterWidth
        let maxLeft =
              this.linkedPages.length * pageOutterWidth - pages.clientWidth + 70

        if (end > maxLeft) {
          end = maxLeft
        }
        let timer = setInterval(() => {
          pages.scrollLeft += 1
          if (pages.scrollLeft >= end) {
            clearInterval(timer)
          }
        }, 1)
      },

      /**
       * Scroll pages section on right arrow click
       */
      right() {
        let pages = document.querySelector('.linked-pages')
        let number = 2
        let pageOutterWidth = 124 + 10 // page width + margin
        let end = pages.scrollLeft - number * pageOutterWidth
        let maxLeft = 0

        if (end < maxLeft) {
          end = maxLeft
        }
        let timer = setInterval(() => {
          pages.scrollLeft -= 1
          if (pages.scrollLeft <= end) {
            clearInterval(timer)
          }
        }, 1)
      },

      /**
       * Retrieve selected autocomplete theme
       * @param {Object} obj - autocomplete object
       */
      setTheme(obj) {
        if (obj) {
          if (obj.selectedObject) {
            if (
              this.bot.topics.theme &&
              this.bot.topics.theme.name !== obj.selectedObject.name
            ) {
              // TODO: in the long term, replace `name' property with `url' prop.
              //       for now, it's hard coded so always different
              if (this.$refs.category) {
                this.$refs.category.clear()
              }
              this.bot.topics.category = undefined
            }
            this.bot.topics.theme = obj.selectedObject
          } else {
            this.bot.topics.theme = undefined
          }
        }
        if (!this.bot.topics.theme || !this.bot.topics.theme.name) {
          if (this.$refs.category) {
            this.$refs.category.clear()
          }
          this.bot.topics.category = undefined
        }

      },

      fetchLanguages() {
        this.listSourcesLanguages('').then(res => {
          this.languages = res.body.languages
        })
      },

      /**
       * Get category from theme selection
       * @param {Object} input - autocomplete object
       */
      getTopic(input) {
        if (!this.bot.topics.theme) {
          return
        }
        return (this.searchSubCategories(this.bot.topics.theme.name, this.bot.topics.lang) + input)
      },

      /**
       * Retrieve selected autocomplete category
       * @param {Object} obj - autocomplete object
       */
      async setTopic(obj) {
        if (obj && obj.selectedObject) {
          this.bot.topics.category = {
            id: obj.selectedObject.id,
            name: obj.selectedObject.name[this.bot.topics.lang]
          }
        }
        if (this.bot.topics.category) {
          await this.loadSources()
        }
      },

      /**
       * Remove blacklists tag
       * @param {Object} item - tag to remove
       */
      remove(item) {
        this.bot.blacklists.splice(this.bot.blacklists.indexOf(item), 1)
      },

      orderBy(list, order, column) {
        return list.sort(function (a, b) {
          return order * (a[column] < b[column])
        })
      },

      sort() {
        this.sources.orders[this.sources.order] =
          this.sources.orders[this.sources.order] * -1
      },

      planning() {
        let len = 24
        // Fill week object
        for (let day in this.bot.planning) {
          let dayArray = {}
          for (let i = 0; i < len; i++) {
            dayArray[i] = true
          }
          this.bot.planning[day] = dayArray
        }
      },

      updatePlanning(day, hour) {
        this.bot.planning[day][hour] = !this.bot.planning[day][hour]
      },

      humanizeTime(minutes) {
        if (minutes === 0) return 'Instant'
        const m = minutes % 60
        const h = Math.floor(minutes / 60)
        const mStr = m ? `${m} min` : ''
        const hStr = h ? `${h}h` : ''

        return `${mStr} ${hStr}`.trim()
      },

      cleanSourceData() {
        this.addSource = false
      },

      toggleEmojiPicker (type) {
        if(type == 'prefix') 
          this.showEmojiPickerPrefix = !this.showEmojiPickerPrefix
        else 
          this.showEmojiPickerSuffix = !this.showEmojiPickerSuffix
      },
      hideEmojiPicker(type) {
        this.showEmojiPickerPrefix = false
        this.showEmojiPickerSuffix = false
      },
      hideEmojiPickerPrefix() {
        this.showEmojiPickerPrefix = false
      },
      hideEmojiPickerSuffix() {
        this.showEmojiPickerSuffix = false
      },
      addEmojiPrefix(emoji) {
        this.addEmoji("hashtag-prefix", emoji)
      },
      addEmojiSuffix(emoji) {
        this.addEmoji("hashtag-suffix", emoji)
      },
      addEmoji(idElement, emoji) {
        const textarea = document.getElementById(idElement);
        const cursorPosition = this.getInputSelection(textarea);
        let start, end
        if(idElement == "hashtag-prefix") {
          start = this.bot.hashtagPrefix.substring(0, cursorPosition.start)
          end = this.bot.hashtagPrefix.substring(cursorPosition.end)
          this.bot.hashtagPrefix = start + emoji.native + end
        }
        else {
          start = this.bot.hashtag.substring(0, cursorPosition.start)
          end = this.bot.hashtag.substring(cursorPosition.end)
          this.bot.hashtag = start + emoji.native + end
        }

        textarea.focus()
        this.$nextTick(() => {
          textarea.selectionStart = (start + emoji.native).length
          textarea.selectionEnd = (start + emoji.native).length
        });
        this.hideEmojiPicker()
      },
      /**
       * Return an 
       * @param {DOMElement} el A dom element of a textarea or input text.
       * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
       **/
      getInputSelection(el) {
        var start = 0, end = 0, normalizedValue, range,
            textInputRange, len, endRange;

        if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
            start = el.selectionStart;
            end = el.selectionEnd;
        } else {
            range = document.selection.createRange();

            if (range && range.parentElement() == el) {
                len = el.value.length;
                normalizedValue = el.value.replace(/\r\n/g, "\n");

                // Create a working TextRange that lives only in the input
                textInputRange = el.createTextRange();
                textInputRange.moveToBookmark(range.getBookmark());

                // Check if the start and end of the selection are at the very end
                // of the input, since moveStart/moveEnd doesn't return what we want
                // in those cases
                endRange = el.createTextRange();
                endRange.collapse(false);

                if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                    start = end = len;
                } else {
                    start = -textInputRange.moveStart("character", -len);
                    start += normalizedValue.slice(0, start).split("\n").length - 1;

                    if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                        end = len;
                    } else {
                        end = -textInputRange.moveEnd("character", -len);
                        end += normalizedValue.slice(0, end).split("\n").length - 1;
                    }
                }
            }
        }

        return {
            start: start,
            end: end
        };
      },

      async getBoardofPinterest(page){
         this.boards = null
          this.selectPinterest = true
          console.log('pinterest page') 
          this.boards = await this.getBoardPinterest(page)
          this.boards = this.boards.body
          if(this.boards)
          this.boardSelected = this.templateStory.boardPinterest || this.boards.board.items[0]
          console.log('boards : ', this.boards)

      },

      async addDefaultBotName(page){
        if(!this.manualName)
          this.bot.name = `${page.name} ${page.network} ${this.bots.filter(b => b.page.id == page.id).length + 1}`

        /**if(page.network == 'pinterest'){
          this.boards = null
          this.selectPinterest = true
          console.log('pinterest page') 
          this.boards = await this.getBoardPinterest(page)
          this.boards = this.boards.body
          console.log('boards : ', this.boards)
        }
        if(page.network != 'pinterest'){
          this.boards = null
          this.selectPinterest = false
        }*/
      },

      manualFrequency(){
        this.bot.frequency = {custom: false, value: 0}
      }

    },

    watch: {

      // showEnabledBots: function(val) {
      //   this.orderedPages()
      // },

      // bots: function(val) {
      //   this.showEnabledBots = this.enabledBotsExists
      // },

      templateMode: function(val) {
        if (val === 'manual') {
          this.templateStory.predefined = null;
        } else if (!this.templateStory.predefined) {
          this.templateStory.predefined = 'template1'
        }
      },

      'bot.posts.mode': function(newVal, oldVal) {
        if(this.selectedPage && this.selectedPage.network === 'instagram'){
          console.log('watch')
          this.bot.instagram.credentials = {};
          this.changeCredential = false;
          if (newVal === 'story' && this.activeSection !== 'edit')
            this.manualFrequency()
        }
        if(newVal != 'standard' && this.bot.posts.display == "none")
          this.bot.posts.display = 'title'
      },

      addBot: function(newVal, oldVal) {
        if(newVal) this.initBot()
      },

      showLimit() {
        if (this.showLimit == 'false' && this.bot.limit > 0) this.bot.limit = 0
      },

      'bot.sourceType': async function () {
        this.allSourcesBtnSelect = !this.bot.sources.length
        await this.loadSources()
      },

      linkedPages() {
        const { clientWidth, scrollWidth } =
              document.querySelector('.linked-pages') || {}
        this.scroll = scrollWidth > clientWidth
      },

      'bot.topics.theme': function (newVal, oldVal) {
        if (newVal === oldVal) return
        this.setTopic({})
      },

      'bot.topics.lang': async function (newVal, oldVal) {
        if (newVal === oldVal) return
        await this.fetchThemes()
        this.setTheme({})
        await this.setTopic({})
        if (!this.sources.filteredSourceList.length) {
          if (this.$refs.category) {
            this.$refs.category.clear()
            this.$refs.category.$el.querySelector('input').focus()
          }
        }
      },

      'bot.page': function (newVal, oldVal) {
        if (newVal === oldVal) return
        this.bot.instagram.credentials = {};
        this.changeCredential = false;
        if(!oldVal){
          //only on create bot
          /*if(!this.bot.id){
            const { network } = this.pages.find(x => x.id === this.bot.page) || {}
            this.bot.utmMedium = network
            let newUtmParams = new URLSearchParams()
            if(this.bot.utmCampaign != '') newUtmParams.set("utm_campaign", this.bot.utmCampaign)
            if(this.bot.utmMedium != '') newUtmParams.set("utm_medium", this.bot.utmMedium)
            if(!!this.bot.utmSource || this.bot.utmSource != '') newUtmParams.set("utm_source", this.bot.utmSource)

            this.bot.utm = newUtmParams.toString()
          }*/
        }
      },
    }
  }
</script>

<style scoped>
.textarea-emoji-picker {
  position: relative;
  margin: 0 auto;
}
.textarea {
  width: 100%;
  min-height: 300px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #BABABA;
  color: #333;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
  resize: vertical;
}
.emoji-mart {
  position: absolute;
  /*top: 33px;
  right: 10px;*/
  top: 0px;
  /*right: calc(-100% + 45px);*/
  right: calc(0px - 357px - 20px);
  z-index: 2;
}
.emoji-trigger {
  position: absolute;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
  height: 20px;
  z-index: 1;
}
.emoji-trigger path {
  transition: 0.1s all;
}
.emoji-trigger:hover path {
  fill: #000000;
}
.emoji-trigger.triggered path {
  fill: darken(#FEC84A, 15%);
}
</style>